import {
  Input,
  InputNumber,
  message,
  Popconfirm,
  Upload,
  Select,
  PageHeader,
  Spin,
  Row,
  Col,
  Form as FormInitial,
  Divider,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  PictureOutlined,
  EyeOutlined,
  CalculatorFilled,
} from "@ant-design/icons";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ModalItem,
  DatePickerItem,
  InputNumberItem,
  SelectItem,
  dineroDisabledMask,
  ButtonItem,
  TextAreaItem,
  InputItem,
  cuentaMask,
  SwitchItem,
  ErrorItem,
  SelectInsumosItem,
  BoxItem,
  CheckItem,
  SelectValorCategoriaItem
} from "../../../../Components/Items";

import AgregarUnidad from "./AgregarUnidad/AgregarUnidad";
import AgregarFamilia from "../../Familias/AgregarFamilia/AgregarFamilia";
import moment from "moment";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import ModalBusquedaURREA from "./ModalBusquedaURREA/ModalBusquedaURREA";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";
import SelectUbicacionesProyectoItem from "../../../../Components/SelectUbicacionesProyectoItem";
import GeneralFormLayout from '../../../../Components/GeneralFormLayout';
import TabbedDynamicTable from '../../../../Components/TabbedDynamicTable';
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import RichTextEditor from "../../../../Components/RichTextEditor";
import { resolverReglaPrecio } from "../../../../Utils/reglasPrecio";
const { Option } = Select;
const { Text } = Typography;
const { Search } = Input;

const equivalenciaEjemplos = [
  { presentacion: "Caja",      cantPres: 1,  base: "Pieza",  cantBase: 12,    factor: 12 },
  { presentacion: "Docena",    cantPres: 1,  base: "Pieza",  cantBase: 12,    factor: 12 },
  { presentacion: "Galón",     cantPres: 1,  base: "Litro",  cantBase: 3.785, factor: 3.785 },
  { presentacion: "Tonelada",  cantPres: 1,  base: "kg",     cantBase: 1000,  factor: 1000 },
  { presentacion: "Pallet",    cantPres: 1,  base: "Caja",   cantBase: 20,    factor: 20 },
  { presentacion: "Pack 6",    cantPres: 1,  base: "Lata",   cantBase: 6,     factor: 6 },
  { presentacion: "Litro",     cantPres: 1,  base: "mL",     cantBase: 1000,  factor: 1000 },
  { presentacion: "Metros",    cantPres: 10, base: "cm",     cantBase: 1000,  factor: 100 },
];

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function DescripcionWebEditor({ value, onChange }) {
  const [htmlMode, setHtmlMode] = React.useState(false);

  const toggleMode = () => setHtmlMode((prev) => !prev);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 4 }}>
        <button
          type="button"
          onClick={toggleMode}
          style={{
            fontSize: 12,
            padding: '2px 10px',
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            background: htmlMode ? '#1890ff' : '#fff',
            color: htmlMode ? '#fff' : '#595959',
            cursor: 'pointer',
          }}
        >
          {htmlMode ? 'Vista visual' : 'HTML crudo'}
        </button>
      </div>
      {htmlMode ? (
        <textarea
          value={value || ''}
          onChange={(e) => onChange?.(e.target.value)}
          rows={8}
          style={{
            width: '100%',
            fontFamily: 'monospace',
            fontSize: 12,
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            padding: 8,
            resize: 'vertical',
            boxSizing: 'border-box',
          }}
          placeholder="Pega aquí el HTML generado por IA..."
        />
      ) : (
        <RichTextEditor
          value={value || ''}
          onChange={onChange}
          placeholder="Descripción para la tienda en línea"
          height={220}
          style={{ width: '100%' }}
        />
      )}
    </div>
  );
}

// Agrupa las categorias hoja bajo el nombre de su categoria principal. Se calcula una sola
// vez al cargar el tab en vez de en cada render.
const agruparCategorias = (categorias, principalesMap) => {
  const grupos = new Map();
  const sueltas = [];
  categorias.forEach((cat) => {
    const padreId = cat.categoriaPadreId ? cat.categoriaPadreId.toString() : null;
    const padreNombre = padreId ? principalesMap[padreId] : null;
    if (padreNombre) {
      if (!grupos.has(padreId)) {
        grupos.set(padreId, { padreId, nombre: padreNombre, hijas: [] });
      }
      grupos.get(padreId).hijas.push(cat);
    } else {
      sueltas.push(cat);
    }
  });
  return { grupos: [...grupos.values()], sueltas };
};

class AgregarInsumo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    ubicacionesPredeterminadas: [],
    loadingEnvios: false,
    buscarInfoCode: false,
    archivosPrincipal: [],
    archivosTecnica: [],
    archivosFotos: [],
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    todasMonedas: null,
    objetoMonedas: null,
    todasUnidades: null,
    objetoUnidades: null,
    todasImpuestos: null,
    objetoImpuestos: null,
    todasFamilia: null,
    objetoFamilia: null,
    todasProveedores: null,
    objetoProveedores: null,
    todasGrupoSat: null,
    objetoGrupoSat: null,
    todasClaseSat: null,
    objetoClaseSat: null,
    todasCodigoSat: null,
    objetoCodigoSat: null,
    todasRetenciones: null,
    objetoRetenciones: null,
    modalAgregarUnidad: false,
    modalAgregarFamilia: false,
    precios: [],
    calcularPreciosAutomaticamente: false,
    calcularPreciosSobre: false,
    impuestoCombustible: false,
    modalAgregarCuentaContable: false,
    todasCuentasContablesFinales: null,
    objetoCuentasContablesFinales: null,
    todasMaterialesPeligrosos: null,
    objetoMaterialesPeligrosos: null,
    todasEmbalajes: null,
    objetoEmbalajes: null,
    todasSectoresCOF: null,
    objetoSectoresCOF: null,
    todasFormasFarmaceuticas: null,
    objetoFormasFarmaceuticas: null,
    todasCondicionesEspeciales: null,
    objetoCondicionesEspeciales: null,
    todasTiposMaterias: null,
    objetoTiposMaterias: null,
    objetoTipoDeInsumo: null,
    todasTipoDeInsumo: [],
    familiaGastoNoDeducible: false,
    unidadPeso: null,
    inventariable: true,
    buscarInfoCodeRA: [],
    objetoCodigoSatRA: [],
    todasCodigoSatRA: [],
    todasMarcas: [],
    objetoMarcas: null,
    apiURREA: false,
    insumoURREA: false,
    modalBusquedaURREA: false,
    codigoURREA: null,
    productoSeleccionado: null,
    codigoSatSeleccionado: null,
    venta: null,
    ventaOnline: false,
    imprimirImagenesCotizaciones : false,
    codBarObligatorio: false,
    valoresPorCategoria: {},
    // Las categorias se cargan hasta que se abre su tab (ver cargarCategoriasDeTab).
    // hayCategoriasInsumo viene de selectDatosParaInsumo y decide si el tab se muestra.
    hayCategoriasInsumo: false,
    loadingCategorias: false,
    categoriasCargadas: false,
    familiaCategoriasCargada: null,
    gruposCategorias: { grupos: [], sueltas: [] },
    equivModal: { visible: false, idx: null },
    equivCalcCantPres: [],
    equivCalcCantBase: [],
    // Listas de precios en crudo y sus reglas de alcance lista, para sembrar el
    // porcentaje sugerido segun la familia y la marca del insumo.
    todasPreciosEmpresa: [],
    reglasPrecioBase: [],
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarTodo();
    this.consultarReglasPrecio();
  }

  consultarReglasPrecio() {
    axios
      .post(
        "reglasPrecio/selectReglasPrecio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            reglasPrecioBase: (res.data.reglas || []).filter(
              (regla) => Number(regla.alcance) === 1
            ),
          });
        }
      })
      .catch((error) => {
        // Sin reglas se sigue usando el porcentaje de la lista, como antes.
        console.error("No se pudieron cargar las reglas de precio:", error);
      });
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "insumos/selectDatosParaInsumo",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState(
            {
              todasGrupoSat: res.data.subclases,
              todasProveedores: res.data.proveedores,
              todasRetenciones: res.data.retenciones,
              todasImpuestos: res.data.impuestos,
              todasFamilia: res.data.familias,
              todasMonedas: res.data.monedas,
              todasUnidades: res.data.unidades,
              todasTipoDeInsumo: res.data.tiposInsumos,
              todasMarcas: res.data.marcas,
              hayCategoriasInsumo: !!res.data.hayCategoriasInsumo,
              calcularPreciosAutomaticamente:
                res.data.configuracion.calcularPreciosAutomaticamente,
              calcularPreciosSobre: res.data.configuracion.calcularPreciosSobre,
              apiURREA: res.data.configuracion.apiURREA,
              ventaOnline: res.data.configuracion.ventaOnline,
              imprimirImagenesCotizaciones : res.data.configuracion.imprimirImagenesCotizaciones, 
              codBarObligatorio: res.data.configuracion.codBarObligatorio,
              // Las listas en crudo: aparte del arreglo del formulario, se
              // necesitan enteras para resolver las reglas de precio.
              todasPreciosEmpresa: res.data.configuracion.precios,
              precios: res.data.configuracion.precios.map((value) => {
                return {
                  porcentaje: value.porcentaje,
                  porcentajeFijo: value.porcentaje,
                  nombre: value.nombre,
                  precioId: value._id,
                };
              }),
              objetoUnidades: res.data.unidades.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
                  </Option>
                );
              }),
              objetoMonedas: res.data.monedas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.abreviacion}
                  </Option>
                );
              }),
              objetoFamilia: res.data.familias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoImpuestos: res.data.impuestos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoRetenciones: res.data.retenciones.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoProveedores: res.data.proveedores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              objetoGrupoSat: res.data.subclases.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + " - " + value.descripcion}
                  </Option>
                );
              }),
              objetoTipoDeInsumo: res.data.tiposInsumos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoMarcas: res.data.marcas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            },
            () => {
              const impuestosPredeterminados = Array.isArray(res.data?.configuracion?.impuestosPredeterminados) ? res.data.configuracion.impuestosPredeterminados : []

              let cargarIP = true
              impuestosPredeterminados.forEach((valueIP) => {
                if (!valueIP?.impuestoId) {
                  cargarIP = false
                }

                if (!this.state.todasImpuestos.find((valueTodasImpuesto) => valueTodasImpuesto._id.toString() === valueIP.impuestoId?.toString())) {
                  cargarIP = false
                }
              })

              const retencionesPredeterminadas = Array.isArray(res.data?.configuracion?.retencionesPredeterminadas) ? res.data.configuracion.retencionesPredeterminadas : []

              let cargarRP = true
              retencionesPredeterminadas.forEach((valueRP) => {
                if (!valueRP?.retencionId) {
                  cargarRP = false
                }
                if (!this.state.todasRetenciones.find((valueTodasRetencion) => valueTodasRetencion._id.toString() === valueRP.retencionId?.toString())) {
                  cargarRP = false
                }
              })

              this.formRef.current.setFieldsValue({
                codigo: res.data.sigNumero,
                clave: res.data.sigNumero,
                impuestos: cargarIP ? impuestosPredeterminados : [],
                retenciones: cargarRP ? retencionesPredeterminadas : [],
                descripcionLargaVenta: false,
                ...(res.data.siHayConfiguracionAutomatizada ? {
                  venta:              res.data?.configuracion?.venta || false,
                  compra:             res.data?.configuracion?.compra || false,
                  verInsumoVenta:     res.data?.configuracion?.verInsumoVenta || false,
                  leyendaVenta:       res.data?.configuracion?.leyendaVenta || false,
                  observaciones:      res.data?.configuracion?.observaciones || false,
                  observacionesVenta: res.data?.configuracion?.observacionesVenta || false,
                  inventariable:      res.data?.configuracion?.inventariable || false,
                  lotesCaducidades:   res.data?.configuracion?.lotesCaducidades || false,
                }: {}),
                valuacionInventarios: res.data.configuracion?.valuacionInventarios,
                precios: res.data.configuracion.precios.map((value) => {
                  return {
                    porcentaje: value.porcentaje,
                    porcentajeFijo: value.porcentaje,
                    nombre: value.nombre,
                    precioId: value._id,
                  };
                }),
              });
            }
          );
        }
      });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentasContablesFinales: res.data });
          this.setState({
            objetoCuentasContablesFinales: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }

  async consultarEnvio() {
    this.setState({ loadingEnvios: true });
    await axios
      .post(
        "insumos/selectDatosParaInsumoEnvio",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState(
            {
              loadingEnvios: false,
              todasMaterialesPeligrosos: res.data.materialesPeligrosos,
              todasEmbalajes: res.data.embalajes,
              unidadPeso: res.data.unidadPeso,
              todasSectoresCOF: res.data.sectoresCOF,
              todasFormasFarmaceuticas: res.data.formasFarmaceuticas,
              todasCondicionesEspeciales: res.data.condicionesEspeciales,
              todasTiposMaterias: res.data.tiposMaterias,
              objetoMaterialesPeligrosos: res.data.materialesPeligrosos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoEmbalajes: res.data.embalajes.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoSectoresCOF: res.data.sectoresCOF.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoFormasFarmaceuticas: res.data.formasFarmaceuticas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoCondicionesEspeciales: res.data.condicionesEspeciales.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoTiposMaterias: res.data.tiposMaterias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
            }
          );
        }
      });
  }


  onChangeGrupo(e, conservar) {
    if (!this.formRef.current) return
    if (conservar !== 'true') {
      this.formRef.current.setFieldsValue({
        claseSatId: undefined,
        codigoSatId: undefined,
      });
    }
    axios
      .post(
        "codigoinsumos/selectClases",
        { empresaId: this.props.empresaId, grupoId: e },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasClaseSat: res.data });
          this.setState({
            objetoClaseSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
  }

  onChangeClase(e, conservar) {
    if (!this.formRef.current) return
    if (conservar !== 'true') { this.formRef.current.setFieldsValue({ codigoSatId: undefined }); }
    axios
      .post(
        "codigoinsumos/selectSubclases",
        { empresaId: this.props.empresaId, claseId: e },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCodigoSat: res.data });
          this.setState({
            objetoCodigoSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_ClaveProdServ + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      })
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  agregarFilaUbicacionPredeterminada = () => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: [...prevState.ubicacionesPredeterminadas, { proyectoId: undefined, ubicacionId: undefined }],
    }));
  };

  actualizarProyectoUbicacionPredeterminada = (index, proyectoId) => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: prevState.ubicacionesPredeterminadas.map((u, i) =>
        i === index ? { proyectoId, ubicacionId: undefined } : u
      ),
    }));
  };

  actualizarUbicacionEnFilaPredeterminada = (index, ubicacionId) => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: prevState.ubicacionesPredeterminadas.map((u, i) =>
        i === index ? { ...u, ubicacionId } : u
      ),
    }));
  };

  eliminarFilaUbicacionPredeterminada = (index) => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: prevState.ubicacionesPredeterminadas.filter((_, i) => i !== index),
    }));
  };


  onFinish(values) {
    this.setState({ loading: true });
    const datosCategorias = Object.entries(values.datosCategoriasMap || {})
      .filter(([, valorId]) => !!valorId)
      .map(([catId, valorId]) => ({
        categoriaInsumoId: catId,
        valorCategoriaInsumoId: valorId,
      }));
    delete values.datosCategoriasMap;

    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    fd.append("datosCategorias", JSON.stringify(datosCategorias));
    const ubicacionesPredeterminadasAGuardar = this.state.ubicacionesPredeterminadas.filter(
      (u) => u.proyectoId && u.ubicacionId
    );
    fd.append("ubicacionesPredeterminadas", JSON.stringify(ubicacionesPredeterminadasAGuardar));
    for (var key in values) {
      if (values[key] === undefined || values[key] === "") {
      } else {
        if (key === "precios") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "equivalencias") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "conversiones") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "impuestos") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "relacionesAutomaticas") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "formasUtilizar") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "insumosRelacionados") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "retenciones") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "proyectos") {
          fd.append(key, JSON.stringify(values[key]));
        } else {
          if (values[key] !== null) {
            fd.append(key, values[key]);
          }
        }
      }
    }
    this.state.archivosPrincipal.forEach((element, index) => {
      fd.append("archivoPrincipal" + (index + 1), element.originFileObj || element);
    });
    this.state.archivosTecnica.forEach((element, index) => {
      fd.append("archivoTecnica" + (index + 1), element.originFileObj || element);
    });
    this.state.archivosFotos.forEach((element, index) => {
      fd.append("archivoFoto" + (index + 1), element.originFileObj || element);
    });
    // Para URLs externas
    const urlsExternasPrincipal = this.state.archivosPrincipal
      .filter(f => f.url)   // Solo los que son URL
      .map(f => f.url);
    const urlsExternasTecnica = this.state.archivosTecnica
      .filter(f => f.url)   // Solo los que son URL
      .map(f => f.url);
    const urlsExternasFotos = this.state.archivosFotos
      .filter(f => f.url)   // Solo los que son URL
      .map(f => f.url);

    fd.append("urlsPrincipal", JSON.stringify(urlsExternasPrincipal));
    fd.append("urlsTecnica", JSON.stringify(urlsExternasTecnica));
    fd.append("urlsFotos", JSON.stringify(urlsExternasFotos));

    fd.append("productoURREA", this.formRef.current.getFieldValue("insumoURREA"));
    fd.append("codigoURREA", this.state.codigoURREA);
    if (this.props?.location?.state?.activo) {
      fd.append("activo", true)
    }
    axios
      .post("insumos/agregarInsumo", fd, {
        headers: {
          ...this.props.headersToken,
        },
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un insumo");
          this.formRef.current.resetFields();
          this.setState({
            archivosPrincipal: [],
            archivosTecnica: [],
            archivosFotos: [],
          });
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se puede registrar el insumo");
        } else {
          message.error(res.data.message || "Hubo un error y el insumo no se registro");
        }
      });
  }

  onBlurDescripcion() {
    if (!this.formRef.current.getFieldValue("descripcionLarga")) {
      let value = this.formRef.current.getFieldValue("descripcion");
      this.formRef.current.setFieldsValue({
        descripcionLarga: value,
      });
    }
  }

  async customRequestFicha(e) {
    const file = e.file;
    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: 'done',
      preview: preview,
      thumbUrl: preview,
      originFileObj: file,
    };
    this.setState({ archivosTecnica: [...this.state.archivosTecnica, fileObj] });
    e.onSuccess("ok");
  }

  onRemoveFileFicha(e) {
    let index = this.state.archivosTecnica.indexOf(e);
    let nuevoArray = this.state.archivosTecnica;
    nuevoArray.splice(index, 1);
    this.setState({ archivosTecnica: nuevoArray });
  }

  async customRequestPrincipal(e) {
    const file = e.file;
    const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isImage) {
      message.error(`${file.name} no es un tipo de imagen válido`);
      e.onError('Tipo de archivo inválido');
      return;
    }

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError('Archivo demasiado grande');
      return;
    }

    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: 'done',
      preview: preview,
      thumbUrl: preview,
      originFileObj: file,
    };

    this.setState({
      archivosPrincipal: [...this.state.archivosPrincipal, fileObj],
    });

    e.onSuccess("ok");
  }


  onRemoveFilePrincipal(e) {
    let index = this.state.archivosPrincipal.indexOf(e);
    let nuevoArray = this.state.archivosPrincipal;
    nuevoArray.splice(index, 1);
    this.setState({ archivosPrincipal: nuevoArray });
  }

  async customRequestFotos(e) {
    const file = e.file;
    const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isImage) {
      message.error(`${file.name} no es un tipo de imagen válido`);
      e.onError('Tipo de archivo inválido');
      return;
    }

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError('Archivo demasiado grande');
      return;
    }

    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: 'done',
      preview: preview,
      thumbUrl: preview,
      originFileObj: file,
    };

    this.setState({
      archivosFotos: [...this.state.archivosFotos, fileObj],
    });

    e.onSuccess("ok");
  }


  onRemoveFileFotos(e) {
    let index = this.state.archivosFotos.indexOf(e);
    let nuevoArray = this.state.archivosFotos;
    nuevoArray.splice(index, 1);
    this.setState({ archivosFotos: nuevoArray });
  }
  abrirAgregarUnidad() {
    this.setState({ modalAgregarUnidad: true });
  }
  cerrarAgregarUnidad(codigo) {
    this.setState({ modalAgregarUnidad: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ unidadId: codigo });
      }
    });
  }
  abrirAgregarFamilia() {
    this.setState({ modalAgregarFamilia: true });
  }
  cerrarAgregarFamilia(codigo) {
    this.setState({ modalAgregarFamilia: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ familiaId: codigo });
      }
    });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo()
  }
  onChangeCosto() {
    const valueCosto = this.formRef.current.getFieldValue("costo");
    if (!valueCosto) return;
    let arrayValues = this.formRef.current.getFieldValue("precios");
    let equivalencias = this.formRef.current.getFieldValue("equivalencias");
    let arrayNuevo = arrayValues.map((value, index) => {
      let precio;
      if (this.state.calcularPreciosSobre) {
        precio = ((valueCosto * (100 + value.porcentaje)) / 100).toFixed(2);
      } else {
        precio = (valueCosto / ((100 - value.porcentaje) / 100)).toFixed(2);
      }
      return { ...value, precio };
    });
    let equivalenciasNuevas;
    if (!equivalencias) {
      equivalenciasNuevas = equivalencias;
    } else {
      equivalenciasNuevas = equivalencias.map((valueE, index) => {
        let arrayPrecios = valueE.precios;
        if (!valueE.equivalencia) return { ...valueE };
        if (!arrayPrecios) return { ...valueE };
        let arrayNuevoPrecios = arrayPrecios.map((valueP, index) => {
          let precio;
          if (this.state.calcularPreciosSobre) {
            precio = (
              ((valueCosto / valueE.equivalencia) * (100 + valueP.porcentaje)) /
              100
            ).toFixed(2);
          } else {
            precio = (
              valueCosto /
              valueE.equivalencia /
              ((100 - valueP.porcentaje) / 100)
            ).toFixed(2);
          }
          return { ...valueP, precio };
        });
        return { ...valueE, precios: arrayNuevoPrecios };
      });
    }
    this.formRef.current.setFieldsValue({
      precios: arrayNuevo,
      equivalencias: equivalenciasNuevas,
    });
  }

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    let preview;

    if (file.url) {
      // Si es una URL externa, usamos directamente la URL
      preview = file.url;
    } else if (file.preview) {
      // Si ya tiene preview base64, usamos eso
      preview = file.preview;
    } else {
      // Si es un archivo subido desde input, generamos base64
      preview = await getBase64(file.originFileObj || file);
      file.preview = preview;
    }

    this.setState({
      previewImage: preview,
      previewVisible: true,
      previewTitle:
        file.name || (file.url ? file.url.substring(file.url.lastIndexOf("/") + 1) : ""),
    });
  };


  onChangeImpuesto() {
    const impuestos = this.formRef.current.getFieldValue('impuestos')
    let combustible = false
    let impuestoIdCombustible
    impuestos.map((valueImpuesto) => {
      if (valueImpuesto?.impuestoId) {
        const impuesto = this.state.todasImpuestos.find((valueTodasImpuesto) => valueTodasImpuesto._id.toString() === valueImpuesto.impuestoId.toString())
        if (impuesto.combustible) {
          combustible = true
          impuestoIdCombustible = impuesto._id
        }
      }
      return null
    })
    if (combustible) {
      message.info('Si el impuesto es especial solamente se puede elegir uno y no se puede vender')
      this.setState({ impuestoCombustible: combustible })
      this.formRef.current.setFieldsValue({ impuestos: [{ impuestoId: impuestoIdCombustible }], venta: false })
    } else {
      this.setState({ impuestoCombustible: combustible })
    }
  }

  onChangeVenta(e) {
    this.setState({ venta: e });
    if (!e) {
      this.formRef.current?.setFieldsValue({ ventaOnline: false });
    }
    if (e) {
      if (!this.state.objetoCodigoSat) {
        this.setState({ buscarInfoCode: true })
        axios
          .post(
            "codigoinsumos/buscarCodigoLista",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken, }
          )
          .then((res) => {
            if (res.data.status === 404) {
            } else {
              this.setState({
                todasCodigoSat: res.data,
                objetoCodigoSat: res.data.map((value) => {
                  return (
                    <Option value={value._id} key={value._id}>
                      {value.c_ClaveProdServ + " - " + value.descripcion}
                    </Option>

                  );
                }),
              });
              this.setState({ buscarInfoCode: false });
            }
          })
      }
    }
  }

  onChangeFamlia(familiaId) {
    const familia = this.state.todasFamilia.find((valueTodasFamilia) => valueTodasFamilia._id.toString() === familiaId.toString())
    if (familia.gastoNoDeducible) {
      message.info('Si la familia es gasto no deducible no se puede inventariar ni vender')
      this.setState({ familiaGastoNoDeducible: true })
      this.formRef.current.setFieldsValue({ inventariable: false, venta: false, flete: false })
    } else {
      this.setState({ familiaGastoNoDeducible: false })
    }
    // Solo se recargan las categorias si el usuario ya abrio el tab; si nunca lo abrio no
    // se pide nada (se cargan al abrirlo, ver cargarCategoriasDeTab).
    if (this.state.categoriasCargadas) {
      this.setState({ categoriasCargadas: false, familiaCategoriasCargada: null }, () =>
        this.cargarCategoriasDeTab(familiaId)
      )
    }
    this.aplicarPorcentajesSugeridos()
  }

  /**
   * Siembra el porcentaje sugerido de cada lista segun las reglas que apliquen a
   * la familia y la marca elegidas. Solo toca las listas cuyo porcentaje sigue
   * siendo el heredado: si el usuario ya tecleo uno, se respeta.
   */
  aplicarPorcentajesSugeridos = () => {
    const reglas = this.state.reglasPrecioBase
    if (!reglas || !reglas.length) return

    const familiaId = this.formRef.current?.getFieldValue("familiaId")
    const marcaId = this.formRef.current?.getFieldValue("marcaId")
    const preciosForm = this.formRef.current?.getFieldValue("precios")
    if (!preciosForm || !preciosForm.length) return

    const nuevosPrecios = preciosForm.map((fila) => {
      const lista = this.state.todasPreciosEmpresa?.find(
        (value) => value._id?.toString() === fila.precioId?.toString()
      )
      if (!lista) return fila

      const regla = resolverReglaPrecio({
        listaBase: lista,
        reglas,
        insumo: { familiaId, marcaId },
      })
      if (regla.porcentaje === undefined) return fila
      // Si el usuario ya cambio el porcentaje a mano, no se le pisa.
      if (Number(fila.porcentaje) !== Number(lista.porcentaje)) return fila

      return { ...fila, porcentaje: regla.porcentaje, porcentajeFijo: regla.porcentaje }
    })

    this.formRef.current.setFieldsValue({ precios: nuevosPrecios })
    // Recalcula los precios con los porcentajes nuevos (lee el costo del form).
    this.onChangeCosto()
  }

  // Trae categorias hoja + principales + TODOS sus valores en una sola request y aplica un
  // unico setState. Antes eran 2 requests + una por cada categoria.
  cargarCategoriasDeTab = (familiaIdParam) => {
    const familiaId = familiaIdParam || this.formRef.current?.getFieldValue("familiaId")
    if (!familiaId) {
      this.setState({
        valoresPorCategoria: {},
        gruposCategorias: { grupos: [], sueltas: [] },
        loadingCategorias: false,
      })
      return
    }
    if (
      this.state.loadingCategorias ||
      (this.state.categoriasCargadas &&
        this.state.familiaCategoriasCargada === familiaId.toString())
    ) {
      return
    }
    this.setState({ loadingCategorias: true })
    axios
      .post(
        "categoriasInsumo/datosCategoriasParaFamilia",
        { empresaId: this.props.empresaId, familiaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loadingCategorias: false })
          return
        }
        const categorias = res.data.categorias || []
        const principalesMap = {}
        ;(res.data.principales || []).forEach((p) => {
          principalesMap[p._id.toString()] = p.nombre
        })
        this.setState({
          valoresPorCategoria: res.data.valores || {},
          gruposCategorias: agruparCategorias(categorias, principalesMap),
          categoriasCargadas: true,
          familiaCategoriasCargada: familiaId.toString(),
          loadingCategorias: false,
        })
      })
      .catch((err) => {
        console.error("Error al consultar categorías aplicables:", err)
        this.setState({ loadingCategorias: false })
      })
  }

  // Solo se usa para refrescar un select puntual despues de agregar un valor nuevo desde
  // el modal; la carga inicial va por cargarCategoriasDeTab.
  consultarValoresCategoria = (categoriaInsumoId) => {
    axios
      .post(
        "valoresCategoriaInsumo/selectValoresPorCategoria",
        { categoriaInsumoId, valor: 1 },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState((prev) => ({
            valoresPorCategoria: {
              ...prev.valoresPorCategoria,
              [categoriaInsumoId]: res.data.valores || [],
            },
          }))
        }
      })
      .catch((err) => console.error("Error al consultar valores:", err))
  }

  onChangeCodigo(value, { autoSelect = false } = {}) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    this.setState({ buscarInfoCode: true })
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasCodigoSat: res.data,
            buscarInfoCode: false,
            objetoCodigoSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_ClaveProdServ + " - " + value.descripcion}
                </Option>

              );
            }),
          });

          if (autoSelect) {
            this.formRef.current?.setFieldsValue({
              codigoSatId: res.data[0]._id,
            });
          }
        }
      })
  }

  onChangeCodigoRelacionesAutomaticas(value, index) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    let buscarInfoCodeRA = this.state.buscarInfoCodeRA
    buscarInfoCodeRA[index] = true
    this.setState({ buscarInfoCodeRA })
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {

          let objetoCodigoSatRA = this.state.objetoCodigoSatRA
          objetoCodigoSatRA[index] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.c_ClaveProdServ + " - " + value.descripcion}
              </Option>

            );
          })
          let buscarInfoCodeRA = this.state.buscarInfoCodeRA
          buscarInfoCodeRA[index] = false
          let todasCodigoSatRA = this.state.todasCodigoSatRA
          todasCodigoSatRA[index] = res.data

          this.setState({
            todasCodigoSatRA,
            buscarInfoCodeRA,
            objetoCodigoSatRA
          });
        }
      })
  }

  onChangeSelectCodigoRelacionesAutomaticas(value, index) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    let buscarInfoCodeRA = this.state.buscarInfoCodeRA
    buscarInfoCodeRA[index] = true
    this.setState({ buscarInfoCodeRA })
    axios
      .post(
        "codigoinsumos/seleccionarCodigoRA",
        { empresaId: this.props.empresaId, codigoSatId: value, insumoId: undefined },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        let buscarInfoCodeRA = this.state.buscarInfoCodeRA
        buscarInfoCodeRA[index] = false

        this.setState({
          buscarInfoCodeRA,
        });
        if (res.data.success !== 2) {
          message.warning(res.data.message ? res.data.message : 'No se puede seleccionar el codigo')

          let relacionesAutomaticas = this.formRef.current.getFieldValue('relacionesAutomaticas')

          relacionesAutomaticas[index].codigoSatId = undefined

          this.formRef.current.setFieldsValue({
            relacionesAutomaticas
          })

        }
      })
  }

  onSearchInsumoURREA = (value) => {
    this.setState({ modalBusquedaURREA: true, codigoURREA: value });
  }
  cerrarModalBusquedaURREA = () => {
    this.setState({ modalBusquedaURREA: false });
    //this.setState(); 
  }

  abrirEquivModal = (idx) => {
    const equivalencias = this.formRef.current.getFieldValue("equivalencias");
    const currentVal = equivalencias?.[idx]?.equivalencia;
    const newState = { equivModal: { visible: true, idx } };
    if (currentVal && !this.state.equivCalcCantBase[idx]) {
      const presArr = [...this.state.equivCalcCantPres];
      const baseArr = [...this.state.equivCalcCantBase];
      presArr[idx] = 1;
      baseArr[idx] = currentVal;
      newState.equivCalcCantPres = presArr;
      newState.equivCalcCantBase = baseArr;
    }
    this.setState(newState);
  }

  cerrarEquivModal = () => {
    this.setState({ equivModal: { visible: false, idx: null } });
  }

  setEquivCalcCantPres = (idx, val) => {
    const arr = [...this.state.equivCalcCantPres];
    arr[idx] = val;
    this.setState({ equivCalcCantPres: arr }, () => this.recalcularEquivalencia(idx));
  }

  setEquivCalcCantBase = (idx, val) => {
    const arr = [...this.state.equivCalcCantBase];
    arr[idx] = val;
    this.setState({ equivCalcCantBase: arr }, () => this.recalcularEquivalencia(idx));
  }

  recalcularEquivalencia = (idx) => {
    const pres = this.state.equivCalcCantPres[idx] || 0;
    const base = this.state.equivCalcCantBase[idx] || 0;
    if (pres > 0) {
      const equivalencias = this.formRef.current.getFieldValue("equivalencias");
      if (!equivalencias[idx]) return;
      equivalencias[idx].equivalencia = parseFloat((base / pres).toFixed(4));
      this.formRef.current.setFieldsValue({ equivalencias });
      this.onChangeCosto();
    }
  }

  // Función que recibe el producto de urrea
  handleConfirmProducto = (producto) => {
    if (producto) {
      if (this.formRef.current) {
        //Buscar unidad SAT
        const unidadSATProducto = producto.unidad;
        const unidadEncontrada = this.state.todasUnidades.find(
          (u) => u.unidadSat?.c_ClaveUnidad === unidadSATProducto
        );
        //Buscar Marca
        const nombreMarcaProducto = producto.marca;
        const marcaEncontrada = this.state.todasMarcas?.find(
          (m) => m.nombre === nombreMarcaProducto
        );
        //Guardar el valor del codigoSat para cuando se busquen cargarlo automaticamente 
        this.formRef.current.setFieldsValue({
          codigoBarras: producto.codigoBarras,
          descripcion: producto.descripcion,
          descripcionLarga: producto.descripcionLarga,
          fotografia: producto.fotografia,
          unidadId: unidadEncontrada?._id || null,
          marcaId: marcaEncontrada?._id || null,
          costo: producto.costo || null,
        });
        //Disparar la búsqueda y seleccionar el primer dato coincidente  
        this.onChangeCodigo(producto.anexoSat, { autoSelect: true });

        const url = producto.fotografia;
        // Tomar lo que está después de la última barra
        const nombreArchivo = url.split('/').pop();
        // Creamos un objeto tipo File “simulado”
        const fileFromUrl = {
          uid: `url-${Date.now()}`,    // UID único
          name: nombreArchivo,         // Nombre que quieres mostrar
          status: "done",
          url: url,                    // La URL de la imagen
          size: 0,
          type: "image/jpeg",          // Tipo MIME (ajústalo si no es jpeg)
          originFileObj: null
        };

        // Añadimos al estado
        this.setState({
          archivosPrincipal: [fileFromUrl]
        });
      }
    } else {
      if (this.formRef.current) {
        this.formRef.current.setFieldsValue({
          codigoBarras: "",
          descripcion: "",
          descripcionLarga: "",
        });
      }
    }
    this.setState({ modalVisible: false });
  };


  render() {
    const { previewVisible, previewImage, previewTitle } = this.state;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={this.props?.location?.state?.activo ? "Agregar Activo" : "Agregar Insumo"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background" style={{ paddingTop: 15 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarInsumo"
              layout
              bottom={
                <ButtonItem
                  hotkey="shift+a"
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Agregar
                </ButtonItem>
              }
              initialValues={{
                fechaCalculo: moment(),
                monedaCompraId: "60c7e4396465ad440c41c15a",
              }}
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
          <GeneralFormLayout
            cards={[
              {
                title: "DATOS GENERALES",
                lg: 24,
                content: (
                   <>
                   <Row gutter={[16, 8]} justify="start">
                      {/*IZQUIERDA*/}
                      <Col xs={24} lg={17} xl={17} xxl={17}>
                        <Row gutter={[8, 4]}>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={5}>
                            <FormItem
                                name="fechaCalculo"
                                label="Fecha"
                                margin
                                labelCol={{ span: 10 }}
                                wrapperCol={{ span: 14 }}
                              >
                                <DatePickerItem
                                  suffixIcon={null}
                                  placeholder="Fecha"
                                  allowClear={false}
                                  disabled
                                  size="small"
                                  style={{ width: '100%' }}
                                />
                            </FormItem>
                             <Row gutter={[8, 0]}>
                            <Col xs={8} sm={24}>
                              <FormItem
                                label="Permitir Venta"
                                name="venta"
                                margin
                                labelCol={{ span: 19}}
                                wrapperCol={{ span: 5 }}
                                initialValue={false}
                                valuePropName="checked"
                              >
                                <SwitchItem disabled={this.state.impuestoCombustible || this.state.familiaGastoNoDeducible} onChange={(e) => this.onChangeVenta(e)} />
                              </FormItem>
                            </Col>
                            <Col xs={8} sm={24}>
                              <FormItem
                                label="P. Venta en línea"
                                name="ventaOnline"
                                margin
                                labelCol={{ span: 19}}
                                wrapperCol={{ span: 5 }}
                                initialValue={false}
                                valuePropName="checked"
                              >
                                <SwitchItem disabled={this.state.impuestoCombustible || this.state.familiaGastoNoDeducible || !this.state.venta || !this.state.ventaOnline} />
                              </FormItem>
                            </Col>
                            <Col xs={8} sm={24}>
                              <FormItem
                                label="Permitir Compra"
                                name="compra"
                                margin
                                labelCol={{ span: 19}}
                                wrapperCol={{ span: 5}}
                                initialValue={true}
                                valuePropName="checked"
                              >
                                <SwitchItem />
                              </FormItem>
                            </Col>
                          </Row>
                        </Col>

                          <Col xs={24} sm={12} md={9} lg={10} xl={10} xxl={11}>
                            <FormItem
                              name="codigo"
                              label="Código"
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                            >
                              <InputItem disabled placeholder="Código" size="small" />
                            </FormItem>
                            <FormItem
                              name="clave"
                              label="Clave"
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                            >
                              <InputItem placeholder="Clave" size="small" />
                            </FormItem>
                            <FormItem
                              name="codigoProveedor"
                              label="Cód. Prov."
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                            >
                              <InputItem placeholder="Cód. Proveedor" size="small" />
                            </FormItem>
                            <FormItem
                              label="Cód. barras"
                              name="codigoBarras"
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                              required={this.state.codBarObligatorio}
                            >
                              <InputItem placeholder="Cód. de barras" size="small" />
                            </FormItem>
                          </Col>

                          <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                            <FormItem
                              label="Marca"
                              name="marcaId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                allowClear
                                placeholder="Marca"
                                size="small"
                                onChange={() => this.aplicarPorcentajesSugeridos()}
                              >
                                {this.state.objetoMarcas}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Costo"
                              name="costo"
                              required
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                              numberCero
                            >
                              <InputNumberItem
                                placeholder="Costo"
                                dinero
                                size="small"
                                onChange={this.onChangeCosto.bind(this)}
                              />
                            </FormItem>
                            <FormItem
                              label="Moneda"
                              name="monedaId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                              initialValue="60c7e4396465ad440c41c15a"
                            >
                              <SelectItem
                                allowClear
                                placeholder="Moneda"
                                size="small"
                              >
                                {this.state.objetoMonedas}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Unidad"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <Input.Group compact>
                                <FormItem name="unidadId" required noStyle>
                                  <SelectItem
                                    placeholder="Unidad"
                                    width="calc(100% - 32px)"
                                    size="small"
                                  >
                                    {this.state.objetoUnidades}
                                  </SelectItem>
                                </FormItem>
                                <ButtonItem
                                  icon={<PlusOutlined />}
                                  size="small"
                                  style={{
                                    width: "28px",
                                    marginLeft: 4,
                                  }}
                                  onClick={this.abrirAgregarUnidad.bind(this)}
                                />
                              </Input.Group>
                            </FormItem>
                          </Col>
                        </Row>

                        <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
                          <Col xs={24}>
                            <FormItem
                              label="Descripción"
                              name="descripcion"
                              required
                              margin
                              labelCol={{ span: 3 }}
                              wrapperCol={{ span: 21 }}
                              pattern
                            >
                              <InputItem
                                placeholder="Descripción"
                                size="small"
                                onBlur={this.onBlurDescripcion.bind(this)}
                              />
                            </FormItem>
                            <FormItem
                              label="Desc. Larga"
                              name="descripcionLarga"
                              required
                              margin
                              labelCol={{ span: 3 }}
                              wrapperCol={{ span: 21 }}
                              pattern
                            >
                              <TextAreaItem
                                placeholder="Descripción larga"
                                rows={2}
                                style={{ resize: 'none' }}
                              />
                            </FormItem>
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.ventaOnline !== curr.ventaOnline}>
                              {({ getFieldValue }) => getFieldValue('ventaOnline') ? (
                                <FormItem
                                  label="Desc. Web"
                                  name="descripcionWeb"
                                  margin
                                  labelCol={{ span: 3 }}
                                  wrapperCol={{ span: 21 }}
                                >
                                  <DescripcionWebEditor />
                                </FormItem>
                              ) : null}
                            </FormItem>
                          </Col>
                        </Row>
                      </Col>

                      {/* DERECHA */}
                      <Col xs={24} lg={7} xl={7} xxl={7}>
                        <Row gutter={[8, 8]}>
                    
                          <Col xs={24} sm={12} lg={24}>

                              <div style={{
                                textAlign: 'center',
                                marginBottom: 8,
                                fontWeight: 600,
                                fontSize: '13px'
                              }}>
                                IMPUESTOS
                              </div>
                              <FormInitial.List name="impuestos">
                                {(fields, { add, remove }) => (
                                  <>
                                    <div style={{ maxHeight: '140px', overflowY: 'auto', paddingRight: '4px' }}>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                          <Col flex="1">
                                            <FormItem
                                              name={[name, "impuestoId"]}
                                              fieldKey={[arrayKey, "impuestoId"]}
                                              required
                                              noStyle
                                            >
                                              <SelectItem
                                                width="100%"
                                                placeholder="Impuesto"
                                                size="small"
                                                onChange={this.onChangeImpuesto.bind(this)}
                                              >
                                                {this.state.objetoImpuestos}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col flex="28px">
                                            <div style={{ textAlign: 'center' }}>
                                              <DeleteOutlined
                                                style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                                onClick={() => {
                                                  remove(name);
                                                  this.onChangeImpuesto();
                                                }}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                    </div>
                                    {!this.state.impuestoCombustible && (
                                      <div style={{ textAlign: 'center', marginTop: 8 }}>
                                        <ButtonItem
                                          type="dashed"
                                          onClick={() => add()}
                                          icon={<PlusOutlined />}
                                          size="small"
                                          block
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    )}
                                  </>
                                )}
                              </FormInitial.List>
                          </Col>

                          <Col xs={24} sm={12} lg={24}>
                            <BoxItem style={{ padding: '10px' }}>
                              <div style={{
                                textAlign: 'center',
                                marginBottom: 8,
                                fontWeight: 600,
                                fontSize: '13px'
                              }}>
                                RETENCIONES
                              </div>
                              <FormInitial.List name="retenciones">
                                {(fields, { add, remove }) => (
                                  <>
                                    <div style={{ maxHeight: '140px', overflowY: 'auto', paddingRight: '4px' }}>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                          <Col flex="1">
                                            <FormItem
                                              name={[name, "retencionId"]}
                                              fieldKey={[arrayKey, "retencionId"]}
                                              required
                                              noStyle
                                            >
                                              <SelectItem
                                                width="100%"
                                                placeholder="Retención"
                                                size="small"
                                              >
                                                {this.state.objetoRetenciones}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col flex="28px">
                                            <div style={{ textAlign: 'center' }}>
                                              <DeleteOutlined
                                                style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                                onClick={() => remove(name)}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                    </div>
                                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                                      <ButtonItem
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                        size="small"
                                        block
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </BoxItem>
                          </Col>

                          {/* URREA */}
                          {this.state.apiURREA && (
                            <Col xs={24} sm={12} lg={24}>
                              <BoxItem style={{ padding: '10px' }}>
                                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: '13px' }}>
                                  URREA
                                </div>
                                <Row gutter={[8, 8]}>
                                  <Col xs={24} sm={12} lg={10}>
                                    <FormItem
                                      label="Insumo"
                                      name="insumoURREA"
                                      margin
                                      labelCol={{ span: 10 }}
                                      wrapperCol={{ span: 14 }}
                                      initialValue={false}
                                      valuePropName="checked"
                                    >
                                      <CheckItem 
                                        disabled={!this.state.apiURREA}
                                        onChange={(value) => {
                                          this.setState({ insumoURREA: value });
                                        }}
                                      />
                                    </FormItem>
                                  </Col>
                                  <Col xs={24} sm={12} lg={14}>
                                    {this.state.insumoURREA && (
                                      <FormItem
                                        label="Código"
                                        name="codigoProducto"
                                        margin
                                        labelCol={{ span: 6}}
                                        wrapperCol={{ span: 18 }}
                                      >
                                        <Search
                                          placeholder="Código"
                                          allowClear
                                          size="small"
                                          onSearch={(value) => {
                                            if (!value || value.trim() === "") {
                                              return;
                                            }
                                            this.onSearchInsumoURREA(value);
                                          }}
                                        />
                                      </FormItem>
                                    )}
                                  </Col>
                                </Row>
                              </BoxItem>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                   </>
    
                ),
              },
            ]}
          />

        <div style={{ marginTop: 25 }}>
         <FormItem noStyle shouldUpdate={(prev, curr) => prev.venta !== curr.venta || prev.ventaOnline !== curr.ventaOnline}>
          {({ getFieldValue }) => {
            const venta = getFieldValue('venta');
            const ventaOnline = getFieldValue('ventaOnline');

            const allTabs = [
              {
              key: 'General',
              label: 'General',
              forceRender: true,
              customContent: (
                <GeneralFormLayout 

                cards={[
                  {
                  title: "TIPO DE INSUMO",
                  lg: 6,
                  content: (
                    <>
                      <Row gutter={[8, 8]}>
                        <Col span={12} xs={24} sm={12} lg={23} xl={23}>
                          <FormItem
                            name="inventariable"
                            label="Inventariable"
                            margin
                            valuePropName="checked"
                            initialValue={true}
                            specialLayoutSwitch
                          >
                            <SwitchItem 
                              onChange={(value) => {
                                if (!value) {
                                  this.formRef.current.setFieldsValue({ marbetes: false, lotesCaducidades: false });
                                } else {
                                  this.formRef.current.setFieldsValue({ flete: false });
                                }
                                this.setState({ inventariable: value });
                              }} 
                              disabled={this.state.familiaGastoNoDeducible}
                            />
                          </FormItem>
                      

                        {this.props.marbetes && (
                    
                            <FormItem
                              name="marbetes"
                              label="Marbetes"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                            >
                              <SwitchItem disabled={!this.state.inventariable || this.state.familiaGastoNoDeducible} />
                            </FormItem>
                
                        )}

                        {this.props.lotesCaducidades && (
                          
                            <FormItem
                              name="lotesCaducidades"
                              label="Lotes y Caducidades"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                              tooltip={{ title: "Utilizar para llevar un control de lotes y caducidades en las compras y ventas" }}
                            >
                              <SwitchItem disabled={!this.state.inventariable} />
                            </FormItem>
                        
                        )}

                        {this.props.fletes && (
                          
                            <FormItem
                              name="flete"
                              label="Flete"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                              tooltip={{ title: "Activara el transporte de mercancia en la venta. Al igual que la carta porte si se tienen los certificados." }}
                            >
                              <SwitchItem disabled={this.state.inventariable || this.state.familiaGastoNoDeducible} />
                            </FormItem>
                        
                        )}
                        <Col span={12} xs={24} sm={12} lg={24} xl={24}>
                              <FormItem
                                    shouldUpdate={(prev, curr) => prev.inventariable !== curr.inventariable || prev.lotesCaducidades !== curr.lotesCaducidades || prev.vehiculo !== curr.vehiculo}
                                    noStyle
                                  >
                                    {({ getFieldValue }) => {
                                      const inventariable = getFieldValue('inventariable');
                                      const lotesCaducidades = getFieldValue('lotesCaducidades');
                                      const vehiculo = getFieldValue('vehiculo');

                                          if (inventariable && lotesCaducidades) {
                                            return (

                                                <>
                                                <FormItem
                                                  name="vehiculo"
                                                  label="Vehículo"
                                                  margin
                                                  valuePropName="checked"
                                                  specialLayoutSwitch
                                                  tooltip={{ title: "Activara este insumo como vehiculo" }}

                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                {vehiculo && (
                                                  <FormItem
                                                    name="desactivarComplementoVehicular"
                                                    label="Des. comp. vehicular"
                                                    margin
                                                    valuePropName="checked"
                                                    specialLayoutSwitch
                                                    tooltip={{ title: "Desactivara el complemento vehicular para este insumo" }}
                                                  >
                                                    <SwitchItem />
                                                  </FormItem>
                                                )}
                                                {this.props.escuela && (
                                                  <>
                                                    <FormItem
                                                      name="libroVirtual"
                                                      label="Libro Virtual"
                                                      margin
                                                      valuePropName="checked"
                                                      specialLayoutSwitch
                                                      tooltip={{ title: "Al confirmarse el pago de una venta con este insumo, se le asignará automáticamente un código de lote único y ya no se pedirá empacarlo físicamente." }}
                                                    >
                                                      <SwitchItem />
                                                    </FormItem>
                                                    <FormItem
                                                      shouldUpdate={(prev, curr) => prev.libroVirtual !== curr.libroVirtual}
                                                      noStyle
                                                    >
                                                      {({ getFieldValue: getFV }) =>
                                                        getFV('libroVirtual') && (
                                                          <FormItem
                                                            name="instruccionesLibroVirtual"
                                                            label="Instrucciones del código"
                                                            margin
                                                            tooltip={{ title: "Se incluye en el correo que recibe el cliente al pagar." }}
                                                          >
                                                            <TextAreaItem rows={3} />
                                                          </FormItem>
                                                        )
                                                      }
                                                    </FormItem>
                                                  </>
                                                )}
                                                </>
                                            );
                                          }
                                          return null;
                                        }}
                                      </FormItem>
                                </Col>
                              </Col>
                            </Row>
                          </>
                            )
                          }, 
                          {
                          lg: 12,
                          group: [
                            {
                              title: "DATOS DE VENTA",
                              content: (
                                <>
                                    <div style={{
                                      textAlign: 'center',
                                      marginBottom: 8,
                                      fontWeight: 600,
                                      fontSize: '13px'
                                    }}>
                                      DATOS FISCALES
                                    </div>
                                    <FormItem
                                      label="Familia"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                    >
                                      <Input.Group compact>
                                        <FormItem name="familiaId" required noStyle>
                                          <SelectItem
                                            placeholder="Familia"
                                            width="85%"
                                            onChange={this.onChangeFamlia.bind(this)}
                                          >
                                            {this.state.objetoFamilia}
                                          </SelectItem>
                                        </FormItem>
                                        <ButtonItem
                                          icon={<PlusOutlined />}
                                          style={{ width: 28, height: 28, marginLeft: 5 }}
                                          onClick={this.abrirAgregarFamilia.bind(this)}
                                        />
                                      </Input.Group>
                                    </FormItem>
                                    <FormItem
                                      label="Tipo Ins."
                                      margin
                                      name="tipoDeInsumoId"
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                    >
                                      <SelectItem placeholder="Tipo de Insumo">
                                        {this.state.objetoTipoDeInsumo}
                                      </SelectItem>
                                    </FormItem>
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) => prev.venta !== curr.venta || prev.equivalencias !== curr.equivalencias}
                                  >
                                    {({ getFieldValue }) => {
                                      const venta = getFieldValue('venta');
                                      const equivalencias = getFieldValue('equivalencias');
                                      const equivalenciasVenta = equivalencias && equivalencias.length > 0
                                        ? equivalencias.some(equivalencia => equivalencia?.venta)
                                        : false;

                                      if (venta || equivalenciasVenta) {
                                        return (
                                          <BoxItem style={{ padding: '10px', marginTop: 10 }}>
                                            <div style={{
                                              textAlign: 'center',
                                              marginBottom: 8,
                                              fontWeight: 600,
                                              fontSize: '13px'
                                            }}>
                                              CODIGOS SAT
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, marginTop: 0 }}>
                                              <FormItem
                                                label="Codigo Sat"
                                                name="codigoSatId"
                                                required
                                                margin
                                                style={{ flex: 1, marginBottom: 0 }}
                                              >
                                                <SelectItem
                                                  mostrarCarga
                                                  loading={this.state.buscarInfoCode}
                                                  placeholder="Codigo Sat"
                                                  onSearch={(value) => { this.onChangeCodigo(value) }}
                                                >
                                                  <Option disabled>Escriba para buscar el codigo</Option>
                                                  {this.state.objetoCodigoSat}
                                                </SelectItem>
                                              </FormItem>
                                              <ButtonItem
                                                style={{ minWidth: 40, padding: '0 8px', height: 28, fontSize: 12 }}
                                                onClick={() => window.open("http://pys.sat.gob.mx/PyS/catPyS.aspx", "_blank")}
                                                size="small"
                                              >
                                                <span style={{ whiteSpace: 'nowrap' }}>Conoce tu código SAT</span>
                                              </ButtonItem>
                                            </div>
                                          </BoxItem>
                                        );
                                      }
                                      return null;
                                    }}
                                  </FormItem>
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) => prev.venta !== curr.venta || prev.familiaId !== curr.familiaId}
                                  >
                                    {({ getFieldValue }) => {
                                      const venta = getFieldValue('venta');
                                      const familiaId = getFieldValue('familiaId');
                                      let familia;

                                      if (familiaId) {
                                        familia = this.state?.todasFamilia?.find(
                                          valueTF => valueTF._id.toString() === familiaId.toString()
                                        );
                                      }

                                      if (venta && (!familia?.cuentaIngresoContadoId || !familia?.cuentaIngresoCreditoId)) {
                                        return (
                                          <BoxItem style={{ padding: '10px', marginTop: 10 }}>
                                            <div style={{
                                              textAlign: 'center',
                                              marginBottom: 8,
                                              fontWeight: 600,
                                              fontSize: '13px'
                                            }}>
                                              CUENTAS DE INGRESO
                                            </div>
                                            <FormItem label="Cuenta Contado" labelCol={{ span: 6 }}wrapperCol={{ span: 18}}  margin>
                                              <Input.Group compact>
                                                <FormItem name="cuentaIngresoContadoId" required noStyle>
                                                  <SelectItem placeholder="Cuenta Ingreso Contado" width="80%">
                                                    {this.state.objetoCuentasContablesFinales}
                                                  </SelectItem>
                                                </FormItem>
                                                <ButtonItem
                                                  icon={<PlusOutlined />}
                                                 style={{ width: 28, height: 28, marginLeft: 5 }}
                                                  blanco
                                                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                />
                                              </Input.Group>
                                            </FormItem>
                                            <FormItem label="Cuenta Credito" labelCol={{ span: 6 }}wrapperCol={{ span: 18}} margin>
                                              <Input.Group compact>
                                                <FormItem name="cuentaIngresoCreditoId" required noStyle>
                                                  <SelectItem placeholder="Cuenta Ingreso Credito" width="80%">
                                                    {this.state.objetoCuentasContablesFinales}
                                                  </SelectItem>
                                                </FormItem>
                                                <ButtonItem
                                                  icon={<PlusOutlined />}
                                                  style={{ width: 28, height: 28, marginLeft: 5 }}
                                                  blanco
                                                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                />
                                              </Input.Group>
                                            </FormItem>
                                          </BoxItem>
                                        );
                                      }
                                      return null;
                                    }}
                                  </FormItem>
                                </>
                                )
                              },
                            ]
                          },
                          ]}
                        />
                      )
                    },
                 ...(venta ? [{
                    key: 'listaPrecios',
                    label: 'Lista de Precios',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm
                            title= "LISTA DE PRECIOS"
                            lg= "100%"
                            style={{ marginTop: 10 }}
                      >

                <FormItem noStyle shouldUpdate={(prev, curr) => prev.venta !== curr.venta}>
                  {({ getFieldValue }) => {
                    const venta = getFieldValue('venta');

                    return (
                      <>
                        {/* Encabezado de la tabla */}
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                            gap: 8,
                            padding: '8px 12px',
                            background: '#fafafa',
                            border: '1px solid #f0f0f0',
                            borderRadius: 8,
                            fontWeight: 600
                          }}
                        >
                          <div>Precio</div>
                          <div style={{ textAlign: "center" }}>% Fijo</div>
                          <div style={{ textAlign: "center" }}>% Real</div>
                          <div style={{ textAlign: "center" }}>Precio</div>
                        </div>

                        <FormInitial.List name="precios">
                          {(fields) => (
                            <div style={{ marginTop: 8 }}>
                              {fields.map(({ key, name }) => (
                                <div
                                  key={key}
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                                    gap: 8,
                                    alignItems: 'center',
                                    padding: '8px 12px',
                                    border: '1px solid #f0f0f0',
                                    borderTop: 'none',
                                    background: '#fff'
                                  }}
                                >
                                  {/* Col 1: Nombre de la lista */}
                                  <div style={{ fontWeight: 500 }}>
                                    {this.state.precios?.[key]?.nombre || `Precio ${key + 1}`}
                                  </div>

                                  {/* Col 2: porcentajeFijo */}
                                  <div>
                                    <FormItem
                                      name={[name, 'porcentajeFijo']}
                                      required
                                      numberCero
                                      noStyle
                                    >
                                      <InputNumberItem porcentaje disabled={!venta} />
                                    </FormItem>
                                  </div>

                                  {/* Col 3: porcentaje */}
                                  <div>
                                    <FormItem
                                      name={[name, 'porcentaje']}
                                      required
                                      numberCero
                                      noStyle
                                    >
                                      <InputNumberItem
                                        porcentaje
                                        disabled={!venta}
                                        onChange={(value) => {
                                          const arrayValue = this.formRef.current.getFieldValue('precios');
                                          const valueCosto = this.formRef.current.getFieldValue('costo');
                                          if (!valueCosto) return;

                                          if (this.state.calcularPreciosSobre) {
                                            arrayValue[key].precio = ((valueCosto * (100 + value)) / 100).toFixed(2);
                                          } else {
                                            arrayValue[key].precio = (valueCosto / ((100 - value) / 100)).toFixed(2);
                                          }

                                          this.formRef.current.setFieldsValue({ precios: arrayValue });
                                        }}
                                      />
                                    </FormItem>
                                  </div>

                                  {/* Col 4: precio */}
                                  <div>
                                    <FormItem
                                      name={[name, 'precio']}
                                      required
                                      numberCero
                                      noStyle
                                    >
                                      <InputNumberItem
                                        placeholder={`Precio de Venta ${this.state.precios?.[key]?.nombre || ''}`}
                                        dinero
                                        disabled={!venta}
                                        onChange={(value) => {
                                          const arrayValue = this.formRef.current.getFieldValue('precios');
                                          const valueCosto = this.formRef.current.getFieldValue('costo');
                                          if (!valueCosto) return;

                                          if (this.state.calcularPreciosSobre) {
                                            arrayValue[key].porcentaje = (((value - valueCosto) / valueCosto) * 100).toFixed(2);
                                          } else {
                                            arrayValue[key].porcentaje = (((value - valueCosto) / value) * 100).toFixed(2);
                                          }

                                          this.formRef.current.setFieldsValue({ precios: arrayValue });
                                        }}
                                      />
                                    </FormItem>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </FormInitial.List>
                      </>
                    );
                  }}
                </FormItem>

                      </DynamicCardForm>
                    )
                  }] : []),
              
                    {
                    key: 'complementos',
                    label: 'Complementos',
                    forceRender: true,
                    customContent: (
                      <>
                       <DynamicCardForm title="COMPLEMENTOS" xs={24} sm={24} md={12} lg={10} xl={10} style={{ marginTop: 10 }}
                       >
                         <>
                        <FormItem shouldUpdate={(prev, curr) => prev.venta !== curr.venta} noStyle >
                          {({ getFieldValue }) => {
                            const venta = getFieldValue('venta');
                            if (venta) {
                              return (
                                <Row gutter={[4, 2]} style={{ marginBottom: 4 }} >
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="observacionesVenta"
                                      label="Observaciones"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara cambiar observaciones en ventas, estas solamente se ven en el pdf" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="verInsumoVenta"
                                      label="Ver Insumo"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara ver el insumo en ventas" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                  <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="insumoCambio"
                                      label="Insumo Cambio"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara que el insumo sea de cambio de cotizaciones a pedido o venta" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="leyendaVenta"
                                      label="Leyenda"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara cambiar leyenda en ventas" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="descripcionLargaVenta"
                                      label="Desc. Larga en PDF"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Al agregar este insumo a una cotización, pedido, embarque o venta, su descripción larga se imprime en el PDF debajo del concepto. Se puede quitar o poner en cada renglón." }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="segundoTicket"
                                      label="2º Ticket"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara el segundo ticket en el punto de venta" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                </Row>
                              );
                            }
                            return null;
                          }}
                        </FormItem>
                        <FormItem shouldUpdate={(prev, curr) => prev.venta !== curr.venta} noStyle>
                          {({ getFieldValue }) => {
                            const venta = getFieldValue('venta');
                            if (venta) {
                              return (
                                <>
                                  <Row gutter={16}> 
                                   <Col span={6} xs={24} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="noFacturable"
                                      label="No Facturable"
                                      margin
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Este insumo no podra ser facturado si se activa" }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>

                                  {this.state.imprimirImagenesCotizaciones && (
                                     <Col span={6} xs={24} sm={12} lg={8} xl={8}>
                                      <FormItem
                                        name="cargarImagen"
                                        label="Cargar Imagen"
                                        margin
                                        valuePropName="checked"
                                        specialLayoutSwitch
                                        tooltip={{ title: "Al activar se podrá cargar una imagen en la cotización" }}
                                      >
                                        <SwitchItem />
                                      </FormItem>
                                    </Col>
                                  )}
                                   </Row>
                                </>
                              );
                            }
                            return null;
                          }}
                        </FormItem>
                        <Row gutter={[4, 2]} style={{ marginTop: 12 }}>
                          <Col span={24}>
                            <FormItem
                              label="Proveedor"
                              name="proveedorDefaultId"
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 19 }}
                              style={{ marginBottom: 4 }}
                            >
                              <SelectItem placeholder="Proveedor default">
                                {this.state.objetoProveedores}
                              </SelectItem>
                            </FormItem>
                          </Col>
                          <Col span={24}>
                            <FormItem
                              label="Compra Mín."
                              name="catidadMinCompra"
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 19 }}
                              numberCero
                              style={{ marginBottom: 0 }}
                            >
                              <InputNumberItem placeholder="Compra Mínima" />
                            </FormItem>
                          </Col>
                        </Row>
                        <Row gutter={[4, 2]} style={{ marginTop: 8 }}>
                          <Col span={24}>
                            <FormItem
                              name="toleranciaRecepcion"
                              label="Tolerancia al Recibir"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                              tooltip={{ title: "Permite recibir (físicamente o por factura) una cantidad mayor a la pedida en la Orden de Compra, hasta el tope configurado, sin bloquear el guardado." }}
                            >
                              <SwitchItem />
                            </FormItem>
                          </Col>
                        </Row>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.toleranciaRecepcion !== curr.toleranciaRecepcion}>
                          {({ getFieldValue }) => {
                            if (!getFieldValue('toleranciaRecepcion')) return null;
                            return (
                              <Row gutter={[4, 2]}>
                                <Col span={12}>
                                  <FormItem
                                    name="tipoToleranciaRecepcion"
                                    label="Tipo"
                                    required
                                    initialValue={1}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <SelectItem placeholder="Tipo de tolerancia">
                                      <Option value={1}>Porcentaje</Option>
                                      <Option value={2}>Cantidad fija</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    name="valorToleranciaRecepcion"
                                    label="Valor"
                                    required
                                    gt={0}
                                    numberCero
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <InputNumberItem placeholder="Valor de la tolerancia" />
                                  </FormItem>
                                </Col>
                              </Row>
                            );
                          }}
                        </FormItem>
                      </>
                     </DynamicCardForm>
                     <DynamicCardForm title="CONFIGURACIÓN ADICIONAL" xs={24} sm={24} md={12} lg={10} xl={10} style={{ marginTop: 10 }}>
                          <FormItem
                            name="activarCuentaPredial"
                            label="Cuenta Predial"
                            margin
                            valuePropName="checked"
                            tooltip={{ title: "Activar para agregar el número de cuenta predial en las ventas" }}
                          >
                              <SwitchItem />
                          </FormItem>
                          <FormItem noStyle shouldUpdate={(prev, curr) => prev.activarCuentaPredial !== curr.activarCuentaPredial}>
                            {({ getFieldValue }) => {
                              const activarCuentaPredial = getFieldValue('activarCuentaPredial');
                              if (activarCuentaPredial) {
                                return (
                                  <FormItem
                                    name="cuentaPredial"
                                    label="Número de Cuenta Predial"
                                    required
                                    pattern
                                  >
                                    <InputItem placeholder="Número de Cuenta Predial" />
                                  </FormItem>
                                );
                              }
                              return null;
                            }}
                          </FormItem>
                     </DynamicCardForm>
                     </>
                    )
                   }, 
                    {
                    key: 'archivoGrafico',
                    label: 'Archivo Gráfico',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm
                        title="ARCHIVO GRÁFICO"
                        lg="100%"
                        style={{ marginTop: 10 }}
                      >
                        <div style={{ marginBottom: 8, fontSize: 12, color: '#8c8c8c', lineHeight: 1.4 }}>
                          <strong>Recomendación de imagen:</strong> usa imágenes <strong>cuadradas (1:1), 1200×1200&nbsp;px</strong>,
                          fondo blanco o transparente y el producto centrado, para que todos los productos
                          se vean parejos en la tienda online. Formatos: JPG/PNG/WebP, máx. 5&nbsp;MB.
                        </div>
                        <Row gutter={[12, 4]}>
                          <Col flex="1">
                            <FormItem name="fotoPrincipal" noStyle>
                               <Upload
                                listType="picture-card"
                                  itemRender={(originNode, file) => (
                                  <div style={{ display: 'inline-block', textAlign: 'center', marginRight: 8 }}>
                                    {originNode}
                                    <div style={{
                                      fontSize: 12,
                                      marginTop: 6,
                                      maxWidth: 104,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {file.name}
                                    </div>
                                  </div>
                                )}
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFilePrincipal(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined onClick={(e) => e.preventDefault()} />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosPrincipal}
                                customRequest={this.customRequestPrincipal.bind(this)}
                                onPreview={this.handlePreview}
                                maxCount={1}
                                accept="image/*"
                                beforeUpload={(file) => {
                                  const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
                                  const isLt5M = file.size / 1024 / 1024 < 5;
                                  if (!isImage) {
                                    message.error(`${file.name} no es un tipo de imagen válido (JPEG/PNG/WEBP)`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  if (!isLt5M) {
                                    message.error(`${file.name} excede el tamaño máximo de 5MB`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  return true;
                                }}
                              >
                                <div>
                                  <PictureOutlined />
                                  <div style={{ marginTop: 8 }}>Foto Principal</div>
                                </div>
                              </Upload>
                              
                            </FormItem>
                            
                          </Col>
                          
                          <Col flex="1">
                            <FormItem name="fichaTecnica" noStyle>
                              <Upload
                                listType="picture-card"
                                  itemRender={(originNode, file) => (
                                  <div style={{ display: 'inline-block', textAlign: 'center', marginRight: 8 }}>
                                    {originNode}
                                    <div style={{
                                      fontSize: 12,
                                      marginTop: 6,
                                      maxWidth: 104,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {file.name}
                                    </div>
                                  </div>
                                )}
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFileFicha(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined onClick={(e) => e.preventDefault()} />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosTecnica}
                                customRequest={this.customRequestFicha.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                              >
                                <div>
                                  <PictureOutlined />
                                  <div style={{ marginTop: 8 }}>Ficha Técnica</div>
                                </div>
                              </Upload>
                            </FormItem>
                          </Col>
                          
                          <Col flex="1">
                            <FormItem name="fotos" noStyle>
                               <Upload
                                listType="picture-card"
                                  itemRender={(originNode, file) => (
                                  <div style={{ display: 'inline-block', textAlign: 'center', marginRight: 8 }}>
                                    {originNode}
                                    <div style={{
                                      fontSize: 12,
                                      marginTop: 6,
                                      maxWidth: 104,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {file.name}
                                    </div>
                                  </div>
                                )}
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFileFotos(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined onClick={(e) => e.preventDefault()} />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosFotos}
                                customRequest={this.customRequestFotos.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                                accept="image/*"
                                beforeUpload={(file) => {
                                  const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
                                  const isLt5M = file.size / 1024 / 1024 < 5;
                                  if (!isImage) {
                                    message.error(`${file.name} no es una imagen válida`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  if (!isLt5M) {
                                    message.error(`${file.name} supera los 5 MB`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  return true;
                                }}
                              >
                                <div>
                                  <PictureOutlined />
                                  <div style={{ marginTop: 8 }}>Fotos</div>
                                </div>
                              </Upload>
                            </FormItem>
                          </Col>
                        </Row>
                      </DynamicCardForm>
                    )
                  },

                    {
                      key: 'relaciones',
                      label: 'Relaciones Automáticas',
                      forceRender: true,
                      customContent: (
                        <DynamicCardForm
                              title= "RELACIONES AUTOMÁTICAS"
                              lg= "100%"
                              style={{ marginTop: 10 }}
                        >
                              
                                <FormInitial.List name="relacionesAutomaticas">
                                  {(fields, { add, remove }) => (
                                    <>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={8} style={{ marginBottom: 8}}>
                                        
                                            <FormItem
                                              name={[name, "codigoSatId"]}
                                              fieldKey={[arrayKey, "codigoSatId"]}
                                              required
                                              noStyle
                                              labelCol={{ span: 6 }}
                                              wrapperCol={{ span: 18}} 
                                            >
                                              <SelectItem
                                                mostrarCarga
                                                width='100%'
                                                loading={this.state.buscarInfoCodeRA[arrayKey]}
                                                placeholder="Codigo Sat"
                                                onSearch={(value) => { 
                                                  this.onChangeCodigoRelacionesAutomaticas(value, arrayKey) 
                                                }}
                                                onChange={(value) => {
                                                  this.onChangeSelectCodigoRelacionesAutomaticas(value, arrayKey)
                                                }}
                                              >
                                                <Option disabled>Escriba para buscar el codigo</Option>
                                                {this.state.objetoCodigoSatRA[arrayKey] ? this.state.objetoCodigoSatRA[arrayKey] : null}
                                              </SelectItem>
                                            </FormItem>
                                          <Col span={2}>
                                            <div style={{ textAlign: 'center', lineHeight: '32px' }}>
                                              <DeleteOutlined
                                                onClick={() => {
                                                  remove(name)
                                                }}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                      <div style={{ textAlign: 'center', marginTop: 12 }}>
                                        <ButtonItem
                                          type="primary"
                                          onClick={() => {
                                            this.onChangeCodigoRelacionesAutomaticas("151015", fields.length)
                                            add()
                                          }}
                                          icon={<PlusOutlined />}
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    </>
                                  )}
                                </FormInitial.List>
                        </DynamicCardForm>
                      ),
                    },
                    {
                      key: 'valuacion',
                      label: 'Valuación de Inventarios',
                      forceRender: true,
                      customContent: (
                       <DynamicCardForm
                        title= "VALUACION DE INVENTARIOS"
                        lg= "100%"
                        style={{ marginTop: 10 }}
                       >
                  
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.inventariable !== curr.inventariable} >
                          {({ getFieldValue }) => {
                            let inventariable = getFieldValue('inventariable')
                            if (inventariable) {
                              return (
                                <>
                                    <FormItem
                                      name="valuacionInventarios"
                                      label="Valuacion"
                                      required
                                      margin
                                    >
                                      <SelectItem placeholder="Valuación de Inventarios">
                                        <Option value={1}>PEPS (Primeras Entradas, Primeras Salidas)</Option>
                                        <Option value={2}>Costo Promedio Ponderado</Option>
                                        <Option value={3}>Costo Especifico</Option>
                                      </SelectItem>
                                    </FormItem>
           
                                </>
                              )
                            } else {
                              return null
                            }
                          }}
                        </FormItem>
                      </DynamicCardForm>
                      )
                    },
                    {
                      key: 'equivalencias',
                      label: 'Equivalencias',
                      forceRender: true,
                      customContent: (
                        <DynamicCardForm
                              title= "EQUIVALENCIAS"
                              lg= "100%"
                              style={{ marginTop: 10 }}
                        >
                      {/* Banner explicativo */}
                      <div style={{
                        background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)',
                        border: '1px solid #91d5ff',
                        borderRadius: 10,
                        padding: '12px 16px',
                        marginBottom: 18,
                        display: 'flex',
                        gap: 12,
                        alignItems: 'flex-start',
                      }}>
                        <div style={{ fontSize: 22, lineHeight: 1, marginTop: 2 }}>💡</div>
                        <div>
                          <div style={{ fontWeight: 700, color: '#0050b3', marginBottom: 4, fontSize: 13 }}>
                            ¿Qué es una equivalencia?
                          </div>
                          <div style={{ color: '#444', fontSize: 12.5, lineHeight: 1.6 }}>
                            Una equivalencia define cómo este insumo puede venderse en una <strong>presentación diferente</strong>.{' '}
                            El factor indica <em>cuántas unidades base</em> contiene esa presentación.
                          </div>
                          <div style={{
                            marginTop: 8,
                            background: '#fff',
                            border: '1px solid #bae7ff',
                            borderRadius: 6,
                            padding: '6px 10px',
                            fontSize: 12,
                            color: '#555',
                            display: 'inline-block',
                          }}>
                            <strong>Ejemplo:</strong> Si el insumo es <em>"Litro"</em> y cuesta $10, una equivalencia{' '}
                            <em>"Caja de 12 litros"</em> con factor <strong>12</strong> tendrá un costo automático de <strong>$120</strong>.
                          </div>
                        </div>
                      </div>

                      <FormInitial.List name="equivalencias">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(
                            ({ key, name, fieldKey, ...restField }, arrayKey) => (
                              <>
                                <Row>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      const descripcionProducto =
                                        getFieldValue("descripcion");
                                      const costo = getFieldValue("costo");
                                      const equivalencias =
                                        getFieldValue("equivalencias");
                                      if (!equivalencias[arrayKey]) return;
                                      const factor = equivalencias[arrayKey].equivalencia;
                                      const descEquiv = equivalencias[arrayKey].descripcion;
                                      const costoEquiv = factor ? costo / factor : 0;
                                      return (
                                        <div style={{
                                          width: '100%',
                                          background: '#f6ffed',
                                          border: '1px solid #b7eb8f',
                                          borderRadius: 6,
                                          padding: '5px 12px',
                                          marginBottom: 8,
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 8,
                                          flexWrap: 'wrap',
                                          fontSize: 12,
                                        }}>
                                          <span style={{ color: '#888' }}>Base:</span>
                                          <strong style={{ color: '#237804' }}>1 × {descripcionProducto || '—'}</strong>
                                          <span style={{ color: '#aaa' }}>⇄</span>
                                          <strong style={{ color: '#237804' }}>{factor || '?'} × {descEquiv || '—'}</strong>
                                          {factor ? (
                                            <span style={{ color: '#555', marginLeft: 4 }}>
                                              · Costo: <strong style={{ color: '#237804' }}>{dineroDisabledMask(costoEquiv || 0)}</strong>
                                              <span style={{ color: '#aaa', fontSize: 11, marginLeft: 4 }}>({dineroDisabledMask(costo || 0)} ÷ {factor})</span>
                                            </span>
                                          ) : null}
                                        </div>
                                      );
                                    }}
                                  </FormItem>
                                   <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                    <FormItem
                                      label="Permitir Venta"
                                      name={[name, "venta"]}
                                      fieldKey={[arrayKey, "venta"]}
                                      margin
                                      initialValue={true}
                                      valuePropName="checked"
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                    <FormItem
                                      label="Venta en línea"
                                      name={[name, "ventaOnline"]}
                                      fieldKey={[arrayKey, "ventaOnline"]}
                                      margin
                                      initialValue={false}
                                      valuePropName="checked"
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                    <FormItem
                                      {...restField}
                                      label="Descripción"
                                      name={[name, "descripcion"]}
                                      fieldKey={[arrayKey, "descripcion"]}
                                      required
                                      max={200}
                                      margin
                                      pattern
                                    >
                                      <InputItem placeholder="Descripción" />
                                    </FormItem>
                                    {/* Opcional: si se deja vacia, la equivalencia usa la
                                        clave del insumo (es la que termina en el
                                        NoIdentificacion del CFDI y en el PDF). */}
                                    <FormItem
                                      {...restField}
                                      label="Clave"
                                      name={[name, "clave"]}
                                      fieldKey={[arrayKey, "clave"]}
                                      max={100}
                                      margin
                                      pattern
                                    >
                                      <InputItem placeholder="Sin clave propia se usa la del insumo" />
                                    </FormItem>
                                    <FormItem
                                      {...restField}
                                      label={
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                          <span>Equivalencia</span>
                                          <EyeOutlined
                                            onClick={() => this.abrirEquivModal(arrayKey)}
                                            style={{ cursor: 'pointer', fontSize: 15, color: '#91d5ff', transition: 'color 0.3s' }}
                                            title="Ver ejemplos"
                                          />
                                          <CalculatorFilled
                                            onClick={() => this.abrirEquivModal(arrayKey)}
                                            style={{ cursor: 'pointer', fontSize: 15, color: '#91d5ff', transition: 'color 0.3s' }}
                                            title="Calcular equivalencia"
                                          />
                                        </div>
                                      }
                                      name={[name, "equivalencia"]}
                                      fieldKey={[arrayKey, "equivalencia"]}
                                      required
                                      margin
                                      number
                                    >
                                      <InputNumberItem
                                        placeholder="Equivalencia"
                                        onChange={this.onChangeCosto.bind(this)}
                                      />
                                    </FormItem>
                                    <FormItem label="Unidad" margin>
                                      <Input.Group compact>
                                        <FormItem
                                          {...restField}
                                          name={[name, "unidadId"]}
                                          fieldKey={[arrayKey, "unidadId"]}
                                          required
                                          margin
                                          pattern
                                          noStyle
                                        >
                                          <SelectItem
                                            placeholder="Unidad"
                                            width="90%"
                                          >
                                            {this.state.objetoUnidades}
                                          </SelectItem>
                                        </FormItem>
                                        <ButtonItem
                                          icon={<PlusOutlined />}
                                          style={{ width: "10%" }}
                                          onClick={this.abrirAgregarUnidad.bind(
                                            this
                                          )}
                                        />
                                      </Input.Group>
                                    </FormItem>
                                  </Col>
                                  <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                    <FormInitial.List
                                      name={[name, "precios"]}
                                      fieldKey={[arrayKey, "precios"]}
                                      initialValue={this.state.precios.map((value) => ({
                                        porcentajeFijo: value.porcentaje,
                                        porcentaje: value.porcentaje,
                                        nombre: value.nombre,
                                        precioId: value.precioId,
                                      }))}
                                    >
                                      {(fields) => (
                                        <>
                                          {/* Encabezado de la tabla */}
                                          <div
                                            style={{
                                              display: 'grid',
                                              gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                                              gap: 8,
                                              padding: '8px 12px',
                                              background: '#fafafa',
                                              border: '1px solid #f0f0f0',
                                              borderRadius: 8,
                                              fontWeight: 600
                                            }}
                                          >
                                            <div>Lista</div>
                                            <div style={{ textAlign: "center" }}>% Fijo</div>
                                            <div style={{ textAlign: "center" }}>% Real</div>
                                            <div style={{ textAlign: "center" }}>Precio</div>
                                          </div>

                                          {/* Filas */}
                                          <div style={{ marginTop: 8 }}>
                                            {fields.map(({ key, name }) => (
                                              <div
                                                key={key}
                                                style={{
                                                  display: 'grid',
                                                  gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                                                  gap: 8,
                                                  alignItems: 'center',
                                                  padding: '8px 12px',
                                                  border: '1px solid #f0f0f0',
                                                  borderTop: 'none',
                                                  background: '#fff'
                                                }}
                                              >
                                                {/* Col 1: Nombre de la lista */}
                                                <div style={{ fontWeight: 500 }}>
                                                  {this.state.precios?.[key]?.nombre || `Precio ${key + 1}`}
                                                </div>

                                                {/* Col 2: porcentajeFijo */}
                                                <div>
                                                  <FormItem
                                                    name={[name, "porcentajeFijo"]}
                                                    required
                                                    numberCero
                                                    noStyle
                                                  >
                                                    <InputNumberItem porcentaje />
                                                  </FormItem>
                                                </div>

                                                {/* Col 3: porcentaje */}
                                                <div>
                                                  <FormItem
                                                    name={[name, "porcentaje"]}
                                                    required
                                                    numberCero
                                                    noStyle
                                                  >
                                                    <InputNumberItem
                                                      porcentaje
                                                      onChange={(value) => {
                                                        const equivalencias = this.formRef.current.getFieldValue("equivalencias");
                                                        const valueCosto = this.formRef.current.getFieldValue("costo");
                                                        if (!valueCosto) return;
                                                        if (!equivalencias[arrayKey]) return;
                                                        if (!equivalencias[arrayKey].equivalencia) return;

                                                        if (this.state.calcularPreciosSobre) {
                                                          equivalencias[arrayKey].precios[key].precio = (
                                                            ((valueCosto / equivalencias[arrayKey].equivalencia) * (100 + value)) / 100
                                                          ).toFixed(2);
                                                        } else {
                                                          equivalencias[arrayKey].precios[key].precio = (
                                                            valueCosto /
                                                            equivalencias[arrayKey].equivalencia /
                                                            ((100 - value) / 100)
                                                          ).toFixed(2);
                                                        }

                                                        // Para evitar “saltos” puedes actualizar solo el path afectado:
                                                        // this.formRef.current.setFields([{ name: ['equivalencias', arrayKey, 'precios', key, 'precio'], value: equivalencias[arrayKey].precios[key].precio }]);
                                                        this.formRef.current.setFieldsValue({ equivalencias });
                                                      }}
                                                    />
                                                  </FormItem>
                                                </div>

                                                {/* Col 4: precio */}
                                                <div>
                                                  <FormItem
                                                    name={[name, "precio"]}
                                                    required
                                                    numberCero
                                                    noStyle
                                                  >
                                                    <InputNumberItem
                                                      placeholder={`Precio de Venta ${this.state.precios?.[key]?.nombre || ''}`}
                                                      dinero
                                                      onChange={(value) => {
                                                        const equivalencias = this.formRef.current.getFieldValue("equivalencias");
                                                        const valueCosto = this.formRef.current.getFieldValue("costo");
                                                        if (!valueCosto) return;
                                                        if (!equivalencias[arrayKey]) return;
                                                        if (!equivalencias[arrayKey].equivalencia) return;

                                                        const base = valueCosto / equivalencias[arrayKey].equivalencia;

                                                        if (this.state.calcularPreciosSobre) {
                                                          equivalencias[arrayKey].precios[key].porcentaje = (
                                                            ((value - base) / base) * 100
                                                          ).toFixed(2);
                                                        } else {
                                                          equivalencias[arrayKey].precios[key].porcentaje = (
                                                            ((value - base) / value) * 100
                                                          ).toFixed(2);
                                                        }

                                                        // Igual, si brinca el foco, usa setFields con path específico:
                                                        // this.formRef.current.setFields([{ name: ['equivalencias', arrayKey, 'precios', key, 'porcentaje'], value: equivalencias[arrayKey].precios[key].porcentaje }]);
                                                        this.formRef.current.setFieldsValue({ equivalencias });
                                                      }}
                                                    />
                                                  </FormItem>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      )}
                                    </FormInitial.List>

                                    <FormItem>
                                      <ButtonItem
                                        style={{
                                          float: "right",
                                          width: "auto",
                                        }}
                                        onClick={() => remove(name)}
                                        block
                                        rojo
                                        icon={<MinusCircleOutlined />}
                                      >
                                        Eliminar Equivalencia
                                      </ButtonItem>
                                    </FormItem>
                                  </Col>
                                </Row>
                                <Divider
                                  style={{ marginBottom: 10, marginTop: 5 }}
                                />
                              </>
                            )
                          )}
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Equivalencia
                            </ButtonItem>
                          </FormItem>
                        </>
                      )}
                    </FormInitial.List>

                    {/* Modal calculadora + ejemplos de equivalencia */}
                    <ModalItem
                      title={(() => {
                        const idx = this.state.equivModal?.idx;
                        if (idx === null || idx === undefined) return 'Equivalencia';
                        const equivs = this.formRef.current?.getFieldValue('equivalencias');
                        const desc = equivs?.[idx]?.descripcion;
                        return desc ? `Equivalencia: ${desc}` : 'Equivalencia';
                      })()}
                      visible={this.state.equivModal?.visible}
                      onCancel={this.cerrarEquivModal}
                      onOk={this.cerrarEquivModal}
                      spinning={false}
                      width={540}
                      footer
                    >
                      {/* Calculadora */}
                      <div style={{ background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: 6, padding: 14, marginBottom: 16 }}>
                        <Text strong style={{ color: '#1890ff', fontSize: 13 }}>Calculadora de equivalencia</Text>
                        <br />
                        <Text type="secondary" style={{ fontSize: 11 }}>
                          Ingrese cuántas unidades base conforman la presentación. El factor se calcula automáticamente.
                        </Text>
                        <Row gutter={12} style={{ marginTop: 10 }}>
                          <Col span={12}>
                            <div style={{ padding: 10, background: 'white', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                              <Text strong style={{ display: 'block', marginBottom: 6, fontSize: 12 }}>Presentación</Text>
                              <Input.Group compact>
                                <InputNumber
                                  min={0.0001}
                                  precision={4}
                                  value={this.state.equivCalcCantPres[this.state.equivModal?.idx] ?? 1}
                                  style={{ width: '38%' }}
                                  onChange={(v) => this.setEquivCalcCantPres(this.state.equivModal?.idx, v)}
                                />
                                <Input
                                  value={this.formRef.current?.getFieldValue('equivalencias')?.[this.state.equivModal?.idx]?.descripcion || ''}
                                  disabled
                                  style={{ width: '62%', backgroundColor: '#f5f5f5', textAlign: 'center', fontSize: 11 }}
                                  placeholder="descripción"
                                />
                              </Input.Group>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ padding: 10, background: 'white', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                              <Text strong style={{ display: 'block', marginBottom: 6, fontSize: 12 }}>Unidad base</Text>
                              <Input.Group compact>
                                <InputNumber
                                  min={0}
                                  precision={4}
                                  value={this.state.equivCalcCantBase[this.state.equivModal?.idx] ?? 0}
                                  style={{ width: '38%' }}
                                  onChange={(v) => this.setEquivCalcCantBase(this.state.equivModal?.idx, v)}
                                />
                                <Input
                                  value={this.formRef.current?.getFieldValue('descripcion') || ''}
                                  disabled
                                  style={{ width: '62%', backgroundColor: '#f5f5f5', textAlign: 'center', fontSize: 11 }}
                                  placeholder="insumo"
                                />
                              </Input.Group>
                            </div>
                          </Col>
                        </Row>
                        {(() => {
                          const idx = this.state.equivModal?.idx;
                          if (idx === null || idx === undefined) return null;
                          const pres = this.state.equivCalcCantPres[idx] || 0;
                          const base = this.state.equivCalcCantBase[idx] || 0;
                          if (!pres) return null;
                          const factor = parseFloat((base / pres).toFixed(4));
                          return (
                            <div style={{ textAlign: 'center', marginTop: 10, fontSize: 12, color: '#555' }}>
                              Factor calculado:{' '}
                              <strong style={{ color: '#237804', fontSize: 16 }}>{factor}</strong>
                            </div>
                          );
                        })()}
                      </div>

                      {/* Tabla de ejemplos */}
                      <div style={{ background: 'white', border: '1px solid #d9d9d9', borderRadius: 6, overflow: 'hidden', fontSize: 11 }}>
                        <div style={{ padding: '8px 12px', background: '#fafafa', borderBottom: '1px solid #d9d9d9', fontWeight: 600, color: '#1890ff' }}>
                          Ejemplos de equivalencias
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 44px 1fr 44px 64px', background: '#e6f7ff', padding: '5px 8px', borderBottom: '1px solid #91d5ff', fontWeight: 600, color: '#0050b3', textAlign: 'center' }}>
                          <div>Presentación</div><div>Cant.</div><div>Unidad Base</div><div>Cant.</div><div>Factor</div>
                        </div>
                        {equivalenciaEjemplos.map((ej, i) => (
                          <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 44px 1fr 44px 64px', padding: '5px 8px', borderBottom: '1px solid #f0f0f0', color: '#595959', textAlign: 'center', background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                            <div>{ej.presentacion}</div>
                            <div>{ej.cantPres}</div>
                            <div>{ej.base}</div>
                            <div>{ej.cantBase}</div>
                            <div style={{ fontWeight: 600, color: '#262626' }}>{ej.factor}</div>
                          </div>
                        ))}
                      </div>
                    </ModalItem>

                       </DynamicCardForm>
                      )
                    },
                    {
                      key: 'envio',
                      label: 'Envío',
                      forceRender: true,
                      customContent: (
                        
                        <Spin spinning={this.state.loadingEnvios}>
                          <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
                            {/* Fila 1: Datos Mercancía - ancho completo */}
                            <DynamicCardForm title="DATOS MERCANCIA" span={24} xs={24} sm={24} lg={14} xl={14}>
                              <Row>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem
                                    name="dimensiones"
                                    label="Dimensiones"
                                    margin
                                     labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 15 }}
                                    pattern
                                  >
                                    <InputItem placeholder="Ejemplo:  59/40/36plg" />
                                  </FormItem>
                                  <FormItem
                                    label="Descripcion Materia"
                                    name="descripcionMateria"
                                    margin
                                    pattern
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 15 }}
                                    tooltip={{ title: "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario." }}
                                  >
                                    <InputItem placeholder="Descripcion Materia" />
                                  </FormItem>
                                  <FormItem label="Tipo Materia" name="tipoMateriaId" margin tooltip={{ title: "Atributo condicional para expresar el estado de la materia o producto al realizar una operación de comercio exterior a través de los distintos medios de transporte." }}
                                   labelCol={{ span: 10 }} wrapperCol={{ span: 15 }}>
                                    <SelectItem placeholder="Tipo Materia" width="100%">
                                      {this.state.objetoTiposMaterias}
                                    </SelectItem>
                                  </FormItem>
                                  
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (getFieldValue('materialPeligroso')) {
                                        return (
                                          <>
                                            <FormItem label="Material Peligroso" name="materialPeligrosoId" margin required>
                                              <SelectItem placeholder="Material Peligroso" width="114%">
                                                {this.state.objetoMaterialesPeligrosos}
                                              </SelectItem>
                                            </FormItem>
                                            <FormItem
                                              name="numCAS"
                                              label="Numero CAS"
                                              margin
                                              pattern
                                              tooltip={{ title: "Atributo condicional para expresar el número Chemical Abstracts Service (CAS) con el que se identifica el compuesto químico de la sustancia tóxica." }}
                                            >
                                              <InputItem placeholder="Numero CAS" />
                                            </FormItem>
                                          </>
                                        )
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem
                                    label="Peso en KGM"
                                    name="pesoEnKGM"
                                    margin
                                    numberCero
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 12 }}
                                  >
                                    <InputNumberItem placeholder="Peso en KGM" />
                                  </FormItem>
                                  <FormItem
                                    label="Clave STCC"
                                    name="claveSTCC"
                                    margin
                                    numberCero
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 12 }}
                                    tooltip={{ title: "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario." }}
                                  >
                                    <InputNumberItem placeholder="Clave STCC" />
                                  </FormItem>
                                  <FormItem
                                    label="Material Peligroso"
                                    name="materialPeligroso"
                                    margin
                                    initialValue={false}
                                    valuePropName="checked"
                                    labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (getFieldValue('materialPeligroso')) {
                                        return (
                                          <>
                                            <FormItem label="Embalaje" name="embalajeId" margin required>
                                              <SelectItem placeholder="Embalaje" width="100%">
                                                {this.state.objetoEmbalajes}
                                              </SelectItem>
                                            </FormItem>
                                            <FormItem
                                              name="descripcionEmbalaje"
                                              label="Descripcion Embalaje"
                                              margin
                                              labelCol={{ span: 8 }}
                                              wrapperCol={{ span: 16 }}
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ejemplo: Cajas de madera contrachapada" />
                                            </FormItem>
                                          </>
                                        )
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>
                            <DynamicCardForm
                                  title="DETALLE MERCANCIA"
                                  span={12}
                                  xs={24}
                                  sm={24}
                                  lg={10}
                                  xl={10}
                                  headerRight={
                                    this.state.unidadPeso ? (
                                      <div style={{ textAlign: 'right', margin: 0, fontSize: 12, fontWeight: 500 }}>
                                        Unidad de peso: {this.state.unidadPeso.nombre} - {this.state.unidadPeso.unidadSat.c_ClaveUnidad}
                                      </div>
                                    ) : null
                                  }
                                >
                                <FormItem
                                  label="Peso Bruto"
                                  name="pesoBruto"
                                  margin
                                  numberCero
                                >
                                  <InputNumberItem placeholder="Peso Bruto" />
                                </FormItem>
                                <FormItem
                                  label="Peso Neto"
                                  name="pesoNeto"
                                  margin
                                  numberCero
                                >
                                  <InputNumberItem placeholder="Peso Neto" />
                                </FormItem>
                                <FormItem
                                  label="Peso Tara"
                                  name="pesoTara"
                                  margin
                                  numberCero
                                >
                                  <InputNumberItem placeholder="Peso Tara" />
                                </FormItem>
                            </DynamicCardForm>
                            {/* Fila 2:*/}
                            <DynamicCardForm title="SECTOR COFEPRIS"  span={12} xs={24} sm={24} lg={13} xl={12}>
                              <FormItem
                                label="Sector COFEPRIS"
                                name="sectorCOFEPRIS"
                                margin
                                initialValue={false}
                                valuePropName="checked"
                              >
                                <SwitchItem />
                              </FormItem>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  if (getFieldValue('sectorCOFEPRIS')) {
                                    return (
                                      <>
                                        <FormItem label="Sector COFEPRIS" name="sectorCOFEPRISId" margin required>
                                          <SelectItem placeholder="Sector COFEPRIS" width="100%">
                                            {this.state.objetoSectoresCOF}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          name="nombreIngredienteActivo"
                                          label="Ingrediente Activo"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar el nombre común del ingrediente activo de los precursores, químicos de uso dual, plaguicidas o fertilizantes que se trasladan a través de los distintos medios de transporte" }}
                                        >
                                          <InputItem placeholder="Ingrediente Activo" />
                                        </FormItem>
                                        <FormItem
                                          name="nombreQuimico"
                                          label="Nombre Quimico"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar el nombre de la sustancia activa de los precursores, químicos de uso dual o sustancias tóxicas que se traslada a través de los distintos medios de transporte." }}
                                        >
                                          <InputItem placeholder="Nombre Quimico" />
                                        </FormItem>
                                        <FormItem
                                          name="denominacionGenericaProd"
                                          label="Denominacion Generica"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar el fármaco o la sustancia activa del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte." }}
                                        >
                                          <InputItem placeholder="Denominacion Generica" />
                                        </FormItem>
                                        <FormItem
                                          name="denominacionDistintivaProd"
                                          label="Denominacion Distintiva"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar la marca con la que se comercializa el producto o nombre que le asigna el laboratorio o fabricante a sus especialidades farmacéuticas con el fin de distinguirlas de otras similares del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte." }}
                                        >
                                          <InputItem placeholder="Denominacion Distintiva" />
                                        </FormItem>
                                        <FormItem
                                          name="fabricante"
                                          label="Fabricante"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar el nombre o razón social del establecimiento que realiza la fabricación o manufactura del medicamento, precursor, químico de uso dual, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte." }}
                                        >
                                          <InputItem placeholder="Fabricante" />
                                        </FormItem>
                                        <FormItem label="Forma Farmaceutica" name="formaFarmaceuticaId" margin>
                                          <SelectItem placeholder="Forma Farmaceutica" width="100%">
                                            {this.state.objetoFormasFarmaceuticas}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem label="Condiciones Especiales" tooltip={{ title: "Atributo condicional para expresar la condición en la cual es necesario mantener el medicamento, precursor, químico de uso dual, psicotrópicos o estupefacientes durante el traslado y almacenamiento." }} name="condicionEspecialId" margin>
                                          <SelectItem placeholder="Condiciones Especiales" width="100%">
                                            {this.state.objetoCondicionesEspeciales}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          name="registroSanitarioFolioAutorizacion"
                                          label="Registro Sanitario"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar el registro sanitario o folio de autorización con el que cuenta la empresa para el traslado del medicamento, psicotrópico o estupefaciente." }}
                                        >
                                          <InputItem placeholder="Registro Sanitario" />
                                        </FormItem>
                                        <FormItem
                                          name="numRegSanPlagCOFEPRIS"
                                          label="Numero Registro"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para expresar el número de registro sanitario para plaguicidas o fertilizantes cuya importación, comercialización y uso están permitidos en México, mismo que emite la Comisión Intersecretarial para el Control del Proceso y Uso de Plaguicidas, Fertilizantes y Sustancias Tóxicas (CICLOPLAFEST)." }}
                                        >
                                          <InputItem placeholder="Numero Registro" />
                                        </FormItem>
                                        <FormItem
                                          name="datosFabricante"
                                          label="Datos Fabricante"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para registrar el país y nombre o razón social de quien produce o fabrica el ingrediente activo del plaguicida o fertilizante." }}
                                        >
                                          <InputItem placeholder="Datos Fabricante" />
                                        </FormItem>
                                        <FormItem
                                          name="datosFormulador"
                                          label="Datos Formulador"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para registrar el país y nombre o razón social de quien formula el ingrediente activo del plaguicida o fertilizante." }}
                                        >
                                          <InputItem placeholder="Datos Formulador" />
                                        </FormItem>
                                        <FormItem
                                          name="datosMaquilador"
                                          label="Datos Maquilador"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para registrar el país y nombre o razón social de quien maquila el ingrediente activo del plaguicida o fertilizante." }}
                                        >
                                          <InputItem placeholder="Datos Maquilador" />
                                        </FormItem>
                                        <FormItem
                                          name="usoAutorizado"
                                          label="Uso Autorizado"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                          tooltip={{ title: "Atributo condicional para registrar el uso autorizado del plaguicida o fertilizante de acuerdo a la regulación del país." }}
                                        >
                                          <InputItem placeholder="Uso Autorizado" />
                                        </FormItem>
                                      </>
                                    )
                                  }
                                }}
                              </FormItem>
                            </DynamicCardForm>

                            
                          </Row>
                        </Spin>
                      )
                    },
                    {
                      key: 'formas',
                      label: 'Formas',
                      forceRender: true,
                      customContent: (
                         <DynamicCardForm
                          title="FORMAS"
                          lg= "100%"
                          style={{ marginTop: 10 }}
                        >
                         
                      <FormInitial.List name="formasUtilizar">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.length > 0 ? (
                            <h1 style={{ textAlign: 'center' }}>Estas formas pertenecen al insumo</h1>
                          ) : null}
                          <table className="table">
                            {fields.length > 0 ? (
                              <thead>
                                <tr>
                                  <th className="th-border" style={{ width: '80%' }}>Forma</th>
                                  <th className="th-border" style={{ width: '2%' }}></th>
                                </tr>
                              </thead>
                            ) : null}
                            {fields.map(
                              ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                <tbody>
                                  <tr>
                                    <td className="td-border">
                                      <FormItem
                                        {...restField}
                                        name={[name, "insumoId"]}
                                        fieldKey={[arrayKey, "insumoId"]}
                                        required
                                        noStyle
                                      >
                                        <SelectInsumosItem
                                          empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                          headersToken={this.props.headersToken}
                                          sinBorde
                                          focusTdIndex={3}
                                          dropdownMatchSelectWidth={600}
                                          width="100%"
                                          placeholder="Insumo"
                                          tiposInsumos="activos"
                                        />
                                      </FormItem>
                                    </td>
                                    <td>
                                      <DeleteOutlined
                                        onClick={() => remove(name)}
                                        style={{
                                          alignSelf: "center",
                                          justifySelf: "center",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              )
                            )}
                          </table>
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={() => add()}
                              lessTime
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Forma
                            </ButtonItem>
                          </FormItem>
                        </>
                      )}
                    </FormInitial.List>
                     </DynamicCardForm>
                      )
                    },
                    ...(ventaOnline ? [{
                      key: 'insumosRelacionados',
                      label: 'Insumos Relacionados',
                      forceRender: true,
                      customContent: (
                         <DynamicCardForm
                          title="INSUMOS RELACIONADOS"
                          lg= "100%"
                          style={{ marginTop: 10 }}
                        >
                          <p style={{ marginBottom: 10, color: '#888', fontSize: 12 }}>
                            Estos productos se mostrarán como “Productos relacionados” únicamente en la
                            tienda en línea. Solo puedes seleccionar insumos con venta en línea activa
                            (los que aparecen ahí).
                          </p>
                      <FormInitial.List name="insumosRelacionados">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.length > 0 ? (
                            <h1 style={{ textAlign: 'center' }}>Estos productos se relacionan con el insumo</h1>
                          ) : null}
                          <table className="table">
                            {fields.length > 0 ? (
                              <thead>
                                <tr>
                                  <th className="th-border" style={{ width: '80%' }}>Insumo</th>
                                  <th className="th-border" style={{ width: '2%' }}></th>
                                </tr>
                              </thead>
                            ) : null}
                            {fields.map(
                              ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                <tbody>
                                  <tr>
                                    <td className="td-border">
                                      <FormItem
                                        {...restField}
                                        name={[name, "insumoId"]}
                                        fieldKey={[arrayKey, "insumoId"]}
                                        required
                                        noStyle
                                      >
                                        <SelectInsumosItem
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          sinBorde
                                          dropdownMatchSelectWidth={600}
                                          width="100%"
                                          placeholder="Seleccionar insumo relacionado"
                                          tiposInsumos="ventaOnline"
                                        />
                                      </FormItem>
                                    </td>
                                    <td>
                                      <DeleteOutlined
                                        onClick={() => remove(name)}
                                        style={{
                                          alignSelf: "center",
                                          justifySelf: "center",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              )
                            )}
                          </table>
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={() => add()}
                              lessTime
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Insumo Relacionado
                            </ButtonItem>
                          </FormItem>
                        </>
                      )}
                    </FormInitial.List>
                     </DynamicCardForm>
                      )
                    }] : []),
                    {
                      key: 'extra',
                      label: 'Extra',
                      forceRender: true,
                      customContent: (
                        <DynamicCardForm title="PROYECTOS" lg="100%" style={{ marginTop: 10 }}>
                          <FormInitial.List name="proyectos">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(({ name }, arrayKey) => (
                                  <Row key={arrayKey} gutter={8} align="middle">
                                    <Col span={22}>
                                      <FormItem
                                        name={[name, "proyectoId"]}
                                        fieldKey={[arrayKey, "proyectoId"]}
                                        required
                                        margin
                                        noStyle
                                      >
                                        <SelectProyectosItem
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          width="100%"
                                          placeholder="Proyecto"
                                        />
                                      </FormItem>
                                    </Col>
                                    <Col span={2}>
                                      <div style={{ textAlign: "center" }}>
                                        <ButtonItem
                                          type="dashed"
                                          rojo2
                                          icon={<DeleteOutlined />}
                                          onClick={() => remove(name)}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                ))}
                                <div style={{ textAlign: "center", marginTop: 12 }}>
                                  <ButtonItem
                                    type="primary"
                                    cyan
                                    onClick={() => add()}
                                    icon={<PlusOutlined />}
                                  >
                                    Agregar
                                  </ButtonItem>
                                </div>
                              </>
                            )}
                          </FormInitial.List>
                        </DynamicCardForm>
                      ),
                    },
                    ...(this.props.moduloWms && this.state.inventariable ? [{
                      key: 'ubicacionesPredeterminadas',
                      label: 'Ubicaciones Predeterminadas',
                      forceRender: true,
                      customContent: (
                        <DynamicCardForm title="UBICACIONES PREDETERMINADAS POR ALMACÉN" lg="100%" style={{ marginTop: 10 }}>
                          {this.state.ubicacionesPredeterminadas.length === 0 && (
                            <div style={{ color: "#999", marginBottom: 12 }}>
                              Aún no hay ubicaciones predeterminadas. Agrega un almacén y su ubicación.
                            </div>
                          )}
                          {this.state.ubicacionesPredeterminadas.map((entrada, index) => (
                            <Row key={index} gutter={8} align="middle" style={{ marginBottom: 8 }}>
                              <Col span={11}>
                                <SelectProyectosItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  width="100%"
                                  placeholder="Almacén"
                                  value={entrada.proyectoId}
                                  onChange={(proyectoId) =>
                                    this.actualizarProyectoUbicacionPredeterminada(index, proyectoId)
                                  }
                                />
                              </Col>
                              <Col span={11}>
                                <SelectUbicacionesProyectoItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  proyectoId={entrada.proyectoId}
                                  width="100%"
                                  value={entrada.ubicacionId}
                                  onChange={(ubicacionId) =>
                                    this.actualizarUbicacionEnFilaPredeterminada(index, ubicacionId)
                                  }
                                />
                              </Col>
                              <Col span={2}>
                                <div style={{ textAlign: "center" }}>
                                  <ButtonItem
                                    type="dashed"
                                    rojo2
                                    icon={<DeleteOutlined />}
                                    onClick={() => this.eliminarFilaUbicacionPredeterminada(index)}
                                  />
                                </div>
                              </Col>
                            </Row>
                          ))}
                          <div style={{ textAlign: "center", marginTop: 12 }}>
                            <ButtonItem
                              type="primary"
                              cyan
                              onClick={this.agregarFilaUbicacionPredeterminada}
                              icon={<PlusOutlined />}
                            >
                              Agregar
                            </ButtonItem>
                          </div>
                        </DynamicCardForm>
                      ),
                    }] : []),
                    // Sin forceRender: el contenido se monta (y recien ahi se piden los
                    // datos) al abrir el tab.
                    ...(this.state.hayCategoriasInsumo ? [{
                      key: 'categorias',
                      label: 'Categorías',
                      customContent: (() => {
                        const { grupos, sueltas } = this.state.gruposCategorias

                        const renderFormItemCat = (cat) => (
                          <FormItem
                            key={cat._id}
                            label={cat.nombre}
                            name={["datosCategoriasMap", cat._id]}
                            margin
                            tooltip={cat.descripcion || `Tipo: ${cat.tipoDato}`}
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <SelectValorCategoriaItem
                              categoria={cat}
                              valores={this.state.valoresPorCategoria[cat._id] || []}
                              empresaId={this.props.empresaId}
                              headersToken={this.props.headersToken}
                              onValorAgregado={() => this.consultarValoresCategoria(cat._id)}
                            />
                          </FormItem>
                        )

                        return (
                          <Spin spinning={this.state.loadingCategorias}>
                            <div style={{ minHeight: 120 }}>
                            {grupos.map((info) => (
                              <DynamicCardForm
                                key={info.padreId}
                                title={info.nombre.toUpperCase()}
                                lg="100%"
                                style={{ marginTop: 10 }}
                              >
                                {info.hijas.map(renderFormItemCat)}
                              </DynamicCardForm>
                            ))}
                            {sueltas.length > 0 && (
                              <DynamicCardForm
                                key="sin-agrupar"
                                title={grupos.length > 0 ? "OTROS CAMPOS" : "CATEGORÍAS"}
                                lg="100%"
                                style={{ marginTop: 10 }}
                              >
                                {sueltas.map(renderFormItemCat)}
                              </DynamicCardForm>
                            )}
                            {this.state.categoriasCargadas &&
                              grupos.length === 0 &&
                              sueltas.length === 0 && (
                                <div style={{ textAlign: "center", padding: 24, color: "#8c8c8c" }}>
                                  No hay categorías configuradas para esta familia
                                </div>
                              )}
                            </div>
                          </Spin>
                        )
                      })(),
                    }] : []),
            ];

            return (
              <TabbedDynamicTable
                formInstance={this.formRef}
                defaultActiveKey="General"
                onTabChange={(key) => {
                  if (key === 'envio' && !this.state.todasMaterialesPeligrosos) {
                    this.consultarEnvio()
                  }
                  if (key === 'categorias') {
                    this.cargarCategoriasDeTab()
                  }
                }}
                tabs={allTabs}
              />
            );
          }}
         </FormItem>
                </div>
            </Form>
          </Spin>
        </div>
        <ModalItem
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
          spinning={false}
          width={450}
        >
          <img alt="vista previa" style={{ width: "100%" }} src={previewImage} />
        </ModalItem>
        <AgregarUnidad
          visible={this.state.modalAgregarUnidad}
          cerrarAgregarUnidad={this.cerrarAgregarUnidad.bind(this)}
        />
        <AgregarFamilia
          visible={this.state.modalAgregarFamilia}
          cerrarAgregarFamilia={this.cerrarAgregarFamilia.bind(this)}
        />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <ModalBusquedaURREA
          visible={this.state.modalBusquedaURREA}
          onClose={this.cerrarModalBusquedaURREA}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          codigoURREA={this.state.codigoURREA}
          onConfirm={this.handleConfirmProducto}

        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    envios: state.empresa.envios,
    marbetes: state.empresa.marbetes,
    fletes: state.empresa.fletes,
    lotesCaducidades: state.empresa.lotesCaducidades,
    taxidermia: state.empresa.taxidermia,
    escuela: state.empresa.escuela,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(AgregarInsumo);